var app_radio_ranker_table = $('#smart-report-table');
$("#custom_details").html($("#custom_details option").sort(function(a, b) {
    return a.text == b.text ? 0 : a.text < b.text ? -1 : 1
}))
$("#estimate_details").html($("#estimate_details option").sort(function(a, b) {
    return a.text == b.text ? 0 : a.text < b.text ? -1 : 1
}))
console.log('html ', $('#custom_details').html());
var html_custom_details= $('#custom_details').html();
var html_estimate_details= $('#estimate_details').html();

var range_option_selected = null;

if ($('#smart-report-form').length) {
    form_wizard('#smart-report-form-wizard',
        {
            'report_advertisers[]': {
                required: true
            },
            "report_campaigns[]": {
                required: true
            },
            "report_media_types[]": {
                required: true
            },
            "display_details[]": {
                required: true
            },
            // "custom_details[]": {
            //     required: true
            // },
            "estimate_details[]": {
                required: true
            },
        },
        {
            "display_details[]": "Please choose at least one display option.",
            "report_media_types[]": "Please choose at least one media type.",
            "report_campaigns[]": "Please choose at least one campaign.",
            "report_advertisers[]": "Please choose at least one advertiser.",
          //  "custom_details[]": "Please choose at least one custom detail.",
            "estimate_details[]": "Please choose at least one estimate detail.",

        }
    );

    $('#smart-previous').on('click', function () {
        if ($('.form_wizard .custom-tabs li.active').attr('id') == 2)
            active_start();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 3)
            active_adv_camp();
       else if ($('.form_wizard .custom-tabs li.active').attr('id') == 4)
            active_brand_prod();
       else if ($('.form_wizard .custom-tabs li.active').attr('id') == 5)
            active_media_market();

    });
    $('.wizard-active-start').on('click', function () {
        active_start();
    });
    $('.wizard-active-adv-camp').on('click', function () {
        active_adv_camp();
    });
    $('.wizard-active-brand-prod').on('click', function () {
        active_brand_prod();
    });
    $('.wizard-active-media-markets').on('click', function () {
        active_media_market();
    });
    $('.wizard-active-details').on('click', function () {
        active_details();
    });
    $('#smart-next').on('click', function () {
        if ($('.form_wizard .custom-tabs li.active').attr('id') == 1)
            active_adv_camp();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 2)
            active_brand_prod();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 3)
            active_media_market();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 4)
            active_details();
    });
    var active_start = function (){
        if ($('#tab2').hasClass('active'))
            $('.wizard-active-adv-camp').removeAttr('aria-expanded');
        if ($('#tab3').hasClass('active'))
            $('.wizard-active-brand-prod').removeAttr('aria-expanded');
        if ($('#tab4').hasClass('active'))
            $('.wizard-active-media-markets').removeAttr('aria-expanded');
        if ($('#tab5').hasClass('active'))
            $('.wizard-active-details').removeAttr('aria-expanded');

        active_clean_all();
        $('#tab1').addClass('active');
        $('#tab1').addClass('content-current');
        $('.li_1').addClass('tab-current');
        $('.li_1').addClass('active');
        $('.wizard-active-start').attr('aria-expanded', true);
        $('#smart-next').css('display', 'inline');
    };
    var active_adv_camp = function () {
        if ($('#tab1').hasClass('active'))
            $('.wizard-active-start').removeAttr('aria-expanded');
        if ($('#tab3').hasClass('active'))
            $('.wizard-active-brand-prod').removeAttr('aria-expanded');
        if ($('#tab4').hasClass('active'))
            $('.wizard-active-media-markets').removeAttr('aria-expanded');
        if ($('#tab5').hasClass('active'))
            $('.wizard-active-details').removeAttr('aria-expanded');

        active_clean_all();
        $('#tab2').addClass('active');
        $('#tab2').addClass('content-current');
        $('.li_2').addClass('tab-current');
        $('.li_2').addClass('active');
        $('.wizard-active-adv-camp').attr('aria-expanded', true);
        $('#smart-next').css('display', 'inline');
        $('#smart-previous').css('display', 'inline');
    };
    var active_brand_prod =  function () {
        if( $('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.<br>' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.<br>' + ' \n';
            var $validator = form_validator('#smart-report-form');
            $validator.focusInvalid();
            $('#generalWarningModalDiv').html(text);
            $('#generalWarningModal').modal('show');
        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab4').hasClass('active'))
                $('.wizard-active-media-markets').removeAttr('aria-expanded');
            if ($('#tab5').hasClass('active'))
                $('.wizard-active-details').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab3').addClass('active');
            $('#tab3').addClass('content-current');
            $('.li_3').addClass('tab-current');
            $('.li_3').addClass('active');
            $('.wizard-active-adv-camp').attr('aria-expanded', true);
            $('#smart-next').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_media_market = function () {
        if( $('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.' + ' \n';
            var $validator = form_validator('#smart-report-form');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab3').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab5').hasClass('active'))
                $('.wizard-active-details').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab4').addClass('active');
            $('#tab4').addClass('content-current');
            $('.li_4').addClass('tab-current');
            $('.li_4').addClass('active');
            $('.wizard-active-media-markets').attr('aria-expanded', true);
            $('#smart-next').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_details = function () {
        if($('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.' + ' \n';
            var $validator = form_validator('#smart-report-form');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else if($('#tab4').hasClass('active')  && ($(".report_media_types_div input:checked").length == 0 || ($('#dma_markets').val().length == 0 && $('#msa_markets').val().length == 0 && $('#custom_markets').val().length == 0))) {
            var text = '';
            if($(".report_media_types_div input:checked").length == 0)
                text += 'Select at least one media type.<br>' + ' \n';
            if($('#dma_markets').val().length == 0 && $('#msa_markets').val().length == 0 && $('#custom_markets').val().length == 0)
                text += 'Select at least one market.<br>' + ' \n';

            var $validator = form_validator('#smart-report-form');
            $validator.focusInvalid();
            $('#generalWarningModalDiv').html(text);
            $('#generalWarningModal').modal('show');

        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab4').hasClass('active'))
                $('.wizard-active-media-markets').removeAttr('aria-expanded');
            if ($('#tab3').hasClass('active'))
                $('.wizard-active-brand-prod').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab5').addClass('active');
            $('#tab5').addClass('content-current');
            $('.li_5').addClass('tab-current');
            $('.li_5').addClass('active');
            $('.wizard-active-details').attr('aria-expanded', true);
            $('#smart-finish').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_clean_all  = function (){
        //clean tabs content
        $('#tab1').removeClass('active');
        $('#tab1').removeClass('content-current');
        $('#tab2').removeClass('active');
        $('#tab2').removeClass('content-current');
        $('#tab3').removeClass('active');
        $('#tab3').removeClass('content-current');
        $('#tab4').removeClass('active');
        $('#tab4').removeClass('content-current');
        $('#tab5').removeClass('active');
        $('#tab5').removeClass('content-current');

        //clean the list
        $('.li_1').removeClass('active');
        $('.li_1').removeClass('tab-current');
        $('.li_2').removeClass('active');
        $('.li_2').removeClass('tab-current');
        $('.li_3').removeClass('active');
        $('.li_3').removeClass('tab-current');
        $('.li_4').removeClass('active');
        $('.li_4').removeClass('tab-current');
        $('.li_5').removeClass('active');
        $('.li_5').removeClass('tab-current');

        //hide bottons
        $('#smart-previous').css('display', 'none');
        $('#smart-next').css('display', 'none');
        $('#smart-finish').css('display', 'none');
    };
    $('#smart-finish').on('click', function(){
        if($('#smart-report-form').valid()) {
            if ($('#automate_report_hidden').val() === 'true' || $('#automate_report_hidden').val() === true || $('#automate_report_hidden').val() === 1) {
                if ($('#email_to_aut').val() === '') {
                    swal({
                            title: "Warning!",
                            text: "You have chosen to automate this report, the email to send it is required.",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {

                    });
                } else {
                    swal({
                            title: "Warning!",
                            text: "You have chosen to automate this report on an " + $("input:radio[name=time_frame]:checked").attr('value').toUpperCase() + " cadence. It will be sent to " + $('#email_to_aut').val() + ".",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm)
                                $('#smart-report-form').submit();

                        });
                }
            }
            else
                $('#smart-report-form').submit();
        }

    });
}

if (app_radio_ranker_table.length) {
    var saved_table_data = [];
    var unsaved_table_data = [];

    var saved_table;
    var unsaved_table;

    $(document).ready(function(){
        smartReportTables();
    });

    var smartReportTables = function(){
        saved_table_data = [];
        unsaved_table_data = [];

        $.ajax({
            type: "GET",
            url: '/smart/report/saved',
            dataType: 'json',
            success: function (data) {
                console.log(data);
                $.each(data['data'], function(index, value){
                    push = {
                        'order': value['order'],
                        'name': value['name'],
                        'smart_type': value['smart_type'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at'],
                        'automate_report': value['automate_report'],
                        'smart_id': value['smart_id'],
                    };
                    saved_table_data.push(push);
                });

                if (saved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#smart-report-saved').DataTable();

                    table.clear();
                    table.rows.add(saved_table_data);
                    table.draw();
                } else {
                    saved_table = $('#smart-report-saved').DataTable({
                        data: saved_table_data,
                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'smart_type'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [0, 'asc'],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 4,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                console.log('rowData', rowData)
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' ;
                                if(rowData.automate_report === 0) {
                                    html += '<a href="/smart/report/view/' +
                                        cellData +
                                        '" role="button" class="btn btn-info btn-sm view_button"> ' +
                                        '<i class="fa fa-eye"></i> View' +
                                        '</a>';
                                }
                                else{
                                    html += '<a href="javascript:void(0)" data-url="/smart/report/view/automate_report/details/' +
                                        rowData.smart_id +
                                        '" role="button" class="btn btn-info btn-sm btn-outline view_details_button"> ' +
                                        '<i class="fa fa-list"></i> Details' +
                                        '</a>';
                                }
                                html +=    '</div><a href="/smart/report/edit/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                                    '<i class="fa fa-pencil"></i> Edit' +
                                    '</a>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                $('#hidden_slug').val($(this).attr('data-slug'));
                                $('#generalWarningModalDeleteReport').modal('show');
                            });
                        }
                    });
                }

            }

        });
        $('#smart-report-saved').on('click', '.view_button', function () {
            init_progress_loader(2, 'Loading Report. Please wait ...');
        });
        $('#smart-report-temp').on('click', '.view_button', function () {
            init_progress_loader(2, 'Loading Report. Please wait ...');
        });
        var columnDefAutomaticReportDetails = [
            {
                headerName: "Sent date",
                field: 'sent_date',
                width: 180,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "Start Date",
                field: 'start_date',
                width: 120,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "End Date",
                field: 'end_date',
                width: 120,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "Time frame",
                field: 'time_frame',
                width: 150,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "File Name",
                field: 'file_name',
                width: 250,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "Sent to",
                field: 'sent_to',
                width: 200,
                cellStyle: {'text-align': "left"},
            },
            {
                headerName: "Path",
                field: 'path',
                width: 200,
                cellStyle: {'text-align': "left"},
                hide: true,
            },

        ];
        var gridAutomaticReportDetails = {
            columnDefs: columnDefAutomaticReportDetails,
            defaultColDef: {
                suppressToolPanel: true
            },
            rowSelection: 'single',
            suppressRowClickSelection: false,
            enableColResize: true,
            suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 20,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };

        $('#smart-report-saved').on('click', '.view_details_button', function () {
           show_loader();
           var url = $(this).attr('data-url')
            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    gridAutomaticReportDetails.rowData = [];
                    gridAutomaticReportDetails.rowData = data.grid_lines;
                    $('#AutomaticReportDetailsModalGridDiv').html("");
                    var gridAutomaticReportDetailsGrid = document.querySelector('#AutomaticReportDetailsModalGridDiv');
                    var g5 = new agGrid.Grid(gridAutomaticReportDetailsGrid, gridAutomaticReportDetails);
                    $('#AutomaticReportDetailsModal').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_loader();
                }
            });
        });
        $('#download_automatic_report_file').on('click', function(e){
            var selected_nodes = gridAutomaticReportDetails.api.getSelectedNodes();
            if(selected_nodes.length > 0) {
                show_overlay_loader($('#AutomaticReportDetailsModal .modal-content'));
                var path = selected_nodes[0].data['path'];
                var a = $("<a style='display: none;'/>");
                var url = path;
                a.attr("href", url);
                a.attr("download", selected_nodes[0].data['file_name']);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();

                hide_overlay_loader($('#AutomaticReportDetailsModal .modal-content'));
            }else{
                swal({
                        title: "Warning!",
                        text: "Select the file first ...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }
        });

        $.ajax({
            type: "GET",
            url: '/smart/report/temp',
            dataType: 'json',
            success: function (data) {
                console.log("temp");
                console.log(data);
                $.each(data['data'], function(index, value){
                    push = {
                        'order':value['order'],
                        'name': value['name'],
                        'smart_type': value['smart_type'],
                        'slug': value['slug'],
                        'created_at': value['human_created_at']
                    };

                    unsaved_table_data.push(push);
                });

                if (unsaved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#smart-report-temp').DataTable();

                    table.clear();
                    table.rows.add(unsaved_table_data);
                    table.draw();
                } else {
                    unsaved_table = $('#smart-report-temp').DataTable({
                        data: unsaved_table_data,
                        columns: [
                            {data: 'order'},
                            {data: 'name'},
                            {data: 'smart_type'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [0, 'asc'],
                        destroy: true,
                        pageLength: user_entries,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 4,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                    '<a href="/smart/report/view/' +
                                    cellData +
                                    '" role="button" class="btn btn-info btn-sm view_button">' +
                                    '<i class="fa fa-eye"></i> View' +
                                    '</a>' +
                                    '</div>' +
                                    '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                    '<i class="fa fa-trash-o"></i> Delete' +
                                    '</a></div>';
                                $(td).html(html);
                            }
                        }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                $('#hidden_slug').val($(this).attr('data-slug'))
                                $('#generalWarningModalDeleteReport').modal('show');
                            });
                        }
                    });
                }
            }
        });
    };

    var deleteConfirmed  = function() {
        var urlVar = '/smart-report/delete/' + $('#hidden_slug').val();
        show_loader();
        $.ajax({
            url: urlVar,
            success: function (response) {
                global_notification('success', 'Report deleted.');
                smartReportTables();
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                smartReportTables();
            }
        });
    }

    $(document).ready(function () {
       var  fd_changed_in= 0;
        var df, dt, arr_df, arr_dt = '';
        if ($("#update_date_from").val() != ""){
            arr_df = $("#update_date_from").val().split(' ')[0].split('-');
            df = arr_df[1] + '/' + arr_df[2] + '/' + arr_df[0];
            arr_dt = $("#update_date_to").val().split(' ')[0].split('-');
            dt = arr_dt[1] + '/' + arr_dt[2] + '/' + arr_dt[0];
        }

        $("#daterange-input-container-11 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });

        var date_flag_value = ""

        $("#daterange-input-container-22 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });

        $('#daterange-input-container-11 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            "startDate": (df == undefined) ? moment().day(8) : df,
            //"endDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            "autoApply": true,
            "dateLimit": {
                "weeks": 53
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        });
        $('#daterange-input-container-22 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            //"startDate": (df == undefined) ? moment().day(8) : df,
            "startDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            //"minDate" : $("#date_range_1").val(),
            "autoApply": true,
            "dateLimit": {
                "weeks": 53
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        });

        if (df !== '' && typeof df !== 'undefined' && typeof df !== undefined && df !== null) {
            //$("#flight_dates_date_range").hide();
            showCalendar(true,false,$('input[name="calendar_type"]:checked').val());
            console.log("false1");
        } else {
            $('#flight_weeks_container').html('<div class="help-text text-center">Please input a Date Range to set this Campaign\'s Flight Weeks.</div>');
            //$('#flight_weeks_inputs').html('');
            showCalendar(true,false,$('input[name="calendar_type"]:checked').val());
            console.log("true1");
        }

        $("#date_range_11").on('click', function() {
            range_option_selected = null;
        });

        $("#date_range_22").on('click', function() {
            range_option_selected = null;
        });

        $("#date_range_11").on('change', function(){
            console.log("#date_range_11",$(this).val(), $("#date_range_22").val(), date_flag_value)
            if(date_flag_value !== $(this).val() && lchange == 0) {
                if (moment($(this).val(), "MM/DD/YYYY") > moment($("#date_range_22").val(), "MM/DD/YYYY")) {
                    $('#date_range_22').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_22").val(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY")).trigger("change")
                } else if ($('#has_orders').val() !== '1') {
                    console.log("true2");
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true, true, $('input[name="calendar_type"]:checked').val());
                } else {
                    console.log("false1");
                }
                fd_changed_in=1;
            }
        });
        $("#date_range_22").on('change', function(){
            console.log("#date_range_22",$("#date_range_11").val(), $(this).val(), date_flag_value)
            if(date_flag_value !== $(this).val() && lchange == 0) {
                if (moment($("#date_range_11").val(), "MM/DD/YYYY") > moment($(this).val(), "MM/DD/YYYY")) {
                    $('#date_range_11').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_11").val(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY")).trigger("change")
                } else if ($('#has_orders').val() !== '1') {
                    console.log("true2");
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true, true, $('input[name="calendar_type"]:checked').val());
                } else {
                    console.log("false2");
                }
                fd_changed_in=1;
            }
        });
        $('.wizard-next-report').on('click', function () {
            console.log('has Active class', $('#tab1').hasClass('active'));
            console.log('fd_changed_in', fd_changed_in);
            if(fd_changed_in == 1 )
                reload_advertisers();
            fd_changed_in=0;
        });
        $('.wizard-active-adv-camp').on('click', function () {
            if(fd_changed_in == 1 )
                reload_advertisers();
            fd_changed_in=0;
        });
        var  reload_advertisers = function () {
            show_loader();
            var params= {
                start:  $("#date_range_11").val(),
                end:  $("#date_range_22").val(),
                camp_sel: $("#report_campaigns").val(),
                brand_sel: $("#report_brands").val(),
            }
            console.log('date_range_start:',$("#date_range_11").val());
            console.log('date_range_end:',$("#date_range_22").val());
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/smart/report/reload/advertisers',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('reload advertiser response', data);
                    var adv_sel=[];
                    $('#report_advertisers option:selected').each(function(){
                        adv_sel.push($(this).val());
                    });
                    var camp_sel=[];
                    $('#report_campaigns option:selected').each(function(){
                        camp_sel.push(parseInt($(this).val()));
                    });

                    var brand_sel=[];
                    $('#report_brands option:selected').each(function(){
                        brand_sel.push($(this).val());
                    });

                    var prod_sel=[];
                    $('#report_products option:selected').each(function(){
                        prod_sel.push($(this).val());
                    });
                    var market_dma=[];
                    $('#dma_markets option:selected').each(function(){
                        market_dma.push($(this).val());
                    });
                    var market_msa=[];
                    $('#msa_markets option:selected').each(function(){
                        market_msa.push($(this).val());
                    });
                    var market_custom=[];
                    $('#custom_markets option:selected').each(function(){
                        market_custom.push($(this).val());
                    });
                    var medias_sel=[];
                    $('.report_media_types_div input:checked').each(function(){
                        medias_sel.push($(this).val());
                    });
                    console.log('medias_sel', medias_sel);

                    var html= '';
                    var a_s=[];
                    var a_sx=[];
                    for(var i in data['adv']) {
                        var ss='';
                        if(adv_sel.indexOf(data['adv'][i].slug) !==-1) {
                            ss = 'selected';
                            a_s.push(data['adv'][i].slug);
                            a_sx.push(data['adv'][i].name);
                        }
                        html += '<option value="' + data['adv'][i].slug + '" '+ss+'>' + data['adv'][i].name + '</option>';
                    }
                    $('#report_advertisers').html(html).multiSelect('refresh');
                    var brand_options=[];
                    var html_cam='';
                    var camp_final_selected=[];
                   for(var i in a_s){
                       if(typeof data['camp'][a_s[i]] !== 'undefined'){
                           html_cam += '<optgroup id="adv_'+ a_s[i] +'" label="'+ a_sx[i].toUpperCase() +'">';
                           for(var x in data['camp'][a_s[i]]) {
                               if (data['camp'][a_s[i]][x].deleted_at === null || data['camp'][a_s[i]][x].archive_year > 0) {
                                   var ss = '';
                                   console.log('x  ', data['camp'][a_s[i]][x].id);
                                   if (camp_sel.indexOf(data['camp'][a_s[i]][x].id) !== -1) {
                                       ss = 'selected';
                                       if (typeof data['brands'][data['camp'][a_s[i]][x].id] !== 'undefined')
                                           brand_options.push(data['brands'][data['camp'][a_s[i]][x].id]);
                                       camp_final_selected.push(data['camp'][a_s[i]][x].id);
                                   }

                                   html_cam += '<option value="' + data['camp'][a_s[i]][x].id + '" ' + ss + '>' + data['camp'][a_s[i]][x].name + '</option>';
                               }
                           }
                           html_cam += '</optgroup>';
                       }
                   }

                    $('#report_campaigns').html(html_cam).multiSelect('refresh');

                    var html_brands=[];
                    var product_options=[];
                    $('#report_brands option').each(function(){
                        if(brand_options.indexOf($(this).attr('value')) !==-1) {
                            var ss='';
                            if(brand_sel.indexOf($(this).attr('value')) !==-1) {
                                ss = 'selected';
                                if(typeof data['products'][$(this).attr('value')] !== 'undefined') {
                                    for(var i in data['products'][$(this).attr('value')])
                                       product_options.push(data['products'][$(this).attr('value')][i]);
                                }
                            }
                            html_brands += '<option value="' + $(this).attr('value') + '" '+ss+'> ' + $(this).html() + ' </option>';
                        }
                    });

                    $('#report_brands').html(html_brands).multiSelect('refresh');

                    var html_prod='';
                    $('#report_products option').each(function(){
                        if(product_options.indexOf($(this).attr('value')) !==-1) {
                            var ss='';
                            if(prod_sel.indexOf($(this).attr('value')) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + $(this).attr('value') + '" '+ss+'> ' + $(this).html() + ' </option>';
                        }
                    });
                    $('#report_products').html(html_prod).multiSelect('refresh');

                    var html_dma='';
                    var html_msa='';
                    var html_custom='';
                    console.log('camp_final_selected', camp_final_selected);
                    console.log('data[markets]', data['markets']);
                    var market_added = [];
                    for(var c in camp_final_selected){
                       var m = camp_final_selected[c];
                        if(typeof data['markets'][m] !== 'undefined'){
                            for(var y in data['markets'][m]){
                                if(market_added.indexOf(data['markets'][m][y].slug) === -1) {
                                    if (data['markets'][m][y].type == 'dma') {
                                        var ss = '';
                                        if (market_dma.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_dma += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    } else if (data['markets'][m][y].type == 'msa') {
                                        var ss = '';
                                        if (market_msa.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_msa += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    }
                                    else {
                                        var ss = '';
                                        if (market_custom.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_custom += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    }

                                    market_added.push(data['markets'][m][y].slug);
                                }
                            }
                        }
                    }
                    $('#custom_markets').html(html_custom).multiSelect('refresh');
                    $('#dma_markets').html(html_dma).multiSelect('refresh');
                    $('#msa_markets').html(html_msa).multiSelect('refresh');

                    var html_media='';
                    var media_type_added = [];
                    for(var c in camp_final_selected){
                        var m = camp_final_selected[c];
                        console.log('m ', m);
                        console.log('data[medias][m]', data['medias'][m]);
                        if(typeof data['medias'][m] !== 'undefined'){
                            for(var y in data['medias'][m]){
                                if(media_type_added.indexOf(data['medias'][m][y].title) === -1) {
                                    var ss = (medias_sel.indexOf(data['medias'][m][y].name) !== -1) ? 'checked' : '';
                                    var disabled = ($('#report_type').val() === 'inv_isci_report' || $('#report_type').val() === 'invoiced_items') && (data['medias'][m][y].name !== 'tv' && data['medias'][m][y].name !== 'cable' && data['medias'][m][y].name !== 'radio') ? 'disabled' : '';
                                    html_media += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                        '           <input id="report_media_' + data['medias'][m][y].name + '" ' +
                                        '           name="report_media_types[]" type="checkbox" value="' + data['medias'][m][y].name + '" ' + ss + ' ' + disabled + '>' +
                                        '           <label for="report_media_' + data['medias'][m][y].name + '"> ' + data['medias'][m][y].title + ' </label>' +
                                        '                                                       </div>';


                                    media_type_added.push(data['medias'][m][y].title);
                                }
                            }
                        }
                    }
                    $('.report_media_types_div').html(html_media);

                    $(".select_all_reports").on("click", function(){
                        var id = $(this).attr("id").split("-")[0];
                        $('#'+id+"").multiSelect("select_all").multiSelect('refresh');
                    });

                    $(".ddeselect_all_reports").on("click", function(){
                        var id = $(this).attr("id").split("-")[0];
                        console.log(id);
                        $('#'+id+"").multiSelect('deselect_all').multiSelect('refresh');
                        if(id == 'report_advertisers'){
                            $('#report_campaigns').html('').multiSelect('refresh');
                            $('#custom_markets').html('').multiSelect('refresh');
                            $('#dma_markets').html('').multiSelect('refresh');
                            $('#msa_markets').html('').multiSelect('refresh');
                            $('#report_brands').html('').multiSelect('refresh');
                            $('#report_products').html('').multiSelect('refresh');
                        }
                        else if(id == 'report_campaigns'){
                            $('#custom_markets').html('').multiSelect('refresh');
                            $('#dma_markets').html('').multiSelect('refresh');
                            $('#msa_markets').html('').multiSelect('refresh');
                            $('#report_brands').html('').multiSelect('refresh');
                            $('#report_products').html('').multiSelect('refresh');
                        }
                        else if(id =='report_brands')
                            $('#report_products').html('').multiSelect('refresh');

                    });


                   hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
        };

        var flight_dates_date_range;
        var start_date;
        var end_date;

        /*$("#weeks_count").on("focusin",function(){
            $(this).data('val',$(this).val())
        }).on("change", function(){
            if($('#has_orders').val() !== '1') {
                var v = parseInt($("#weeks_count").val());
                if (v > 0) {
                    lchange = 1;
                    console.log("new: " + v);
                    // var interv = $("#date_range").val();
                    // interv = interv.split(" - ");
                    var interv = [$('#date_range_11').val(), $('#date_range_22').val()]
                    var start = moment(interv[0], "MM/DD/YYYY");
                    var end = moment(interv[1], "MM/DD/YYYY");
                    var va = $("input:radio[name=flength]:checked").attr('value');
                    var unvisible_weeks = $("#hiatus_weeks option").sort(function(a,b){return new Date(b.value) - new Date(a.value);});
                    var start = moment(interv[0], "MM/DD/YYYY");

                    var aux = start.clone();
                    if (va === "d") {
                        aux.add(v - 1 , 'days');
                    } else {
                        aux.add((v * 7) - 1, 'days');
                    }
                    console.log(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                    //$("#date_range").val(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                    $('#date_range_11').val(start.format("MM/DD/YYYY"))
                    $('#date_range_22').val(aux.format("MM/DD/YYYY"))
                    $('#date_range_11').data('daterangepicker').setStartDate(start.format("MM/DD/YYYY"))
                    $('#date_range_22').data('daterangepicker').setStartDate(aux.format("MM/DD/YYYY"))
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true,true,$('input[name="calendar_type"]:checked').val());
                    lchange = 0;

                    //return end.diff(start, 'days');
                } else {
                    global_notification('warning', 'Incorrect number of flight weeks ... ');
                    $("#weeks_count").val("0");
                }
            }
        });*/

        /*$(".flength_w").on('click', function(){
            console.log("in");
            var v = $("input:radio[name=flength]:checked").attr('value');
            if(v === 'w'){
                console.log("last w: " + last);
                if(last === "" || last === "d") {
                    last = v;
                    var au = parseInt($("#weeks_count").val());
                    console.log((au / 7).toFixed(0));
                    $("#weeks_count").val(Math.ceil(au/7));
                    //$("#weeks_count").val($("#flight_weeks_inputs input").length);
                }
            }
        });*/
        /*$(".flength_d").on('click', function(){
            console.log("in");
            var v = $("input:radio[name=flength]:checked").attr('value');
            if(v === 'd') {
                console.log("last d: " + last);
                if(last === "" || last === "w") {
                    last = v;
                    $("#weeks_count").val(calc_diff_days());
                }
            }
        });*/

        $('input[name="calendar_type"]').on("click",function(){
            if(range_option_selected !== null){
                $('#'+range_option_selected).click();
            }
            showCalendar(true,true,$(this).val())
        });

        function showCalendar(b,flag = false,calendar_type = "weeks"){
            var hiatus_weeks = $("#hiatus_weeks option").map(function(x) { return $("#hiatus_weeks option")[x].value.replace(new RegExp(' ','g'),""); }).toArray();
            $("#hiatus_weeks").html("");
            //temp = $('#date_range').val().split(" - ");
            temp = [$('#date_range_11').val(), $('#date_range_22').val()]

            start_date = moment(temp[0], 'MM/DD/YYYY');
            end_date = moment(temp[1], 'MM/DD/YYYY');

            var months = [];
            temp_start = moment(temp[0], 'MM/DD/YYYY');

            while(true){
                months.push([temp_start.format('M'), temp_start.format('YYYY')]);
                temp_start.add(1, 'month');
                if(temp_start.isAfter(moment(end_date).add(1, 'month').date(1))){
                    break;
                }
            }
            if(months.length <= 3) {
                auxm = 200;
            }else{
                if(months.length % 3 === 0){
                    auxm = (months.length/3) * 200;
                }else{
                    auxm = ((months.length/3).toFixed(0) + 1) * 200;
                }
            }
            cheight = 0;

            var weeks = [];
            temp_start = moment(temp[0], 'MM/DD/YYYY');
            var auxWeekYers = {};
            console.log()
            while(true){
                let weekNumber = temp_start.week();
                if (temp_start.weekday() === 0) {
                    weekNumber = temp_start.week() - 1;
                }
                if(typeof auxWeekYers[weekNumber + '' + temp_start.year()] === "undefined") {
                    console.log('temp_start_temp_start ', temp_start.format('MM/DD/YYYY'), weekNumber);
                    auxWeekYers[weekNumber + '' + temp_start.year()] = [weekNumber, temp_start.year()]
                    weeks.push({
                        week: weekNumber,
                        year: temp_start.year()
                    });
                }
                //temp_start.add(1, 'week');
                temp_start.add(1, 'days');
                if(temp_start.isSameOrAfter(moment(end_date).add(1, 'day'))){
                    break;
                }
            }
            var v = $("input:radio[name=flength]:checked").attr('value');

            weeks = collect(weeks);

            var container = $('#flight_weeks_container');
            container.html('');

            var inputs_container = $('#flight_weeks_inputs');
            var validate_fufllfill = $("#flight_weeks_inputs input").length;
            //inputs_container.html('');

            var month_count = 0;

            if(calendar_type !== "weeks" && months.length > 1 && moment(temp[0], 'MM/DD/YYYY').isoWeek() === moment().seconds(0).minutes(0).hours(0).date(1).month(parseInt(months[1][0]) - 1).year(months[1][1]).isoWeek())
                months.splice(0, 1);

            $.each(months, function(index, value){
                month_count++;

                var html = '';

                if((month_count % 3) === 0){
                    html += '<div class="row">';
                }

                var month_start = moment()
                    .seconds(0)
                    .minutes(0)
                    .hours(0)
                    .date(1)
                    .month(parseInt(value[0]) - 1)
                    .year(value[1]);

                html += '<div class="col-md-4 m-b-10" style="min-width: 300px"><div class="flight-date-calendar"><div class="calendar-wrapper"><table><tbody><tr class="heading"><td colspan="2" class="first"></td><td colspan="7"><div class="month">' + month_start.format('MMM YYYY') + '</div></td></tr><tr class="weekday"><td class="first">&nbsp;</td><td>#</td><td>M</td><td>T</td><td>W</td><td>R</td><td>F</td><td>S</td><td>U</td></tr>';

                calendar_start = moment(month_start).startOf('isoWeek');
                calendar_end = moment(month_start).add(1, 'month').startOf('isoWeek');

                if((calendar_end.date() !== 1 && calendar_type === "weeks") || (calendar_end.date() !== 1 && month_count === months.length)){
                    calendar_end.add(1, 'week');
                }

                while(calendar_end.isAfter(calendar_start)){
                    if (calendar_start.day() === 1) {
                        let auxYear = moment(calendar_start).year()
                        let auxYear2 = moment(calendar_start).add(5, 'days').year()
                        let auxWeek = moment(calendar_start).week()
                        if(auxYear < auxYear2 && auxYear2 === end_date.year())
                            auxYear = auxYear2;
                        if(typeof weeks.where('year', auxYear).where('week', auxWeek).first() === 'undefined'){
                            html += '</tr><tr class="days"><td class="day select out-of-range"></td><td></td>';
                        }else{
                            var sel = (!b || (flag && hiatus_weeks.length > 0 && hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) !== -1)) ? 'unselected' : 'selected';
                            html += '</tr><tr class="days '+ sel +'"><td class="day select in-range" data-date="' + calendar_start.format('YYYY-MM-DD') + '"><i class="fa fa-check fa-fw"></i></td><td class="day weeknum"> ' + calendar_start.week() + '</td>';

                            if(inputs_container.find('input[name="campaign_weeks[]"][value="' + calendar_start.format('YYYY-MM-DD') + '"]').length === 0){
                                console.log("hiden: " + calendar_start.format('YYYY-MM-DD'));
                                if(validate_fufllfill === 0 && (!flag || hiatus_weeks.length == 0 || hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) === -1))
                                    inputs_container.append('<input type="hidden" name="campaign_weeks[]" value="' + calendar_start.format('YYYY-MM-DD') + '" value="true" />');
                            }
                        }
                    }

                    classes = 'day ';

                    if((parseInt(calendar_start.format('YYYYMMDD')) < parseInt(start_date.format('YYYYMMDD')))
                        || (parseInt(calendar_start.format('YYYYMMDD')) > parseInt(end_date.format('YYYYMMDD')))){
                        classes += 'out-of-range ';
                    }

                    if(value[0] !== calendar_start.format('M') && calendar_type === "weeks"){
                        classes += 'out-of-month ';
                    }

                    html += '<td class="' + classes + '">' + calendar_start.format('DD') + '</td>';

                    calendar_start.add(1, 'day');
                }
                html += '</tr>';

                html += '</tbody></table></div></div></div>';

                if(((month_count % 3) === 2) || (month_count === months.length)){
                    html += '</div>';
                }

                container.append(html);

                var auu = [];
                var hhtml = "";
                $.each($('td.day.select'), function(){
                    var auxx = $(this).attr('data-date');
                    if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                        var au = $(this).attr('data-date').split("-");
                        au = au[1] + " / " + au[2] + " / " + au[0];
                        if (auu.indexOf(au) === -1) {
                            auu.push(au);
                            hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                        }
                    }
                });
                $("#hiatus_weeks").html(hhtml);
                sort_hiatus();

                if(!b){
                    var upd_weeks = $("#update_weeks").val();
                    if(upd_weeks !== ""){
                        console.log("upd weeks");
                        console.log(upd_weeks);
                        var html = '';
                        var arr = upd_weeks.split('|');
                        var ins_aux = [];
                        // for(var i=0;i<arr.length-1;i++){
                        //     var aux1 = arr[i].split(' ');
                        //     console.log("divide");
                        //     console.log(aux1);
                        //     //var aux = aux1[4].split('-');
                        //     html += '<input type="hidden" name="campaign_weeks[]" value="'+ aux1[0].trim() +'">';
                        //     $.each($('td.day.select[data-date="' + aux1[0].trim() + '"]'), function(){
                        //         //$(this).closest('.days').removeClass('unselected').addClass('selected');
                        //     });
                        // }

                        $("#flight_weeks_inputs input").each(function (index,value) {
                            html += '<input type="hidden" name="campaign_weeks[]" value="'+ $(value).val().trim() +'">';
                            $.each($('td.day.select[data-date="' + $(value).val().trim() + '"]'), function(){
                                $(this).closest('.days').removeClass('unselected').addClass('selected');
                            });
                        })

                        // var auu = [];
                        // var hhtml = "";
                        // $.each($('td.day.select'), function(){
                        //     var auxx = $(this).attr('data-date');
                        //     if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                        //         var au = $(this).attr('data-date').split("-");
                        //         au = au[1] + " / " + au[2] + " / " + au[0];
                        //         if (auu.indexOf(au) === -1) {
                        //             auu.push(au);
                        //             hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                        //         }
                        //     }
                        // });
                        // $("#hiatus_weeks").html(hhtml);
                        // sort_hiatus();
                        inputs_container.html('');
                        inputs_container.html(html);
                    }
                }

            });

            if(lchange === 0) {
                console.log("EDIT");
                if (v === "w") {
                    last = v;
                    //$("#weeks_count").val($("#flight_weeks_inputs input").length);
                    console.log("WEEKS DIFFERENCE: ",calc_diff_weeks())
                    //$("#weeks_count").val(calc_diff_weeks());
                } else {
                    last = v;
                    //$("#weeks_count").val(calc_diff_days());
                }
            }

            $("#removeall").on('click', function(){
                $('#hiatus_weeks option').each(function(){
                    var daux = $(this).val().split(' / ');
                    daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                    var lastd = "";
                    container.find('td.day.select').each(function(){
                        var date = $(this).attr('data-date');
                        if(daux === date) {
                            console.log(date + "  " + lastd);
                            if(date !== lastd) {
                                $(this).click();
                                lastd = date;
                            }
                        }else
                            console.log(date + " " + daux);
                    });
                    $(this).remove();
                });
            });

            $("#removesel").on('click', function(){
                $('#hiatus_weeks option:selected').each(function(){
                    var daux = $(this).val().split(" / ");
                    daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                    var lastw = "";
                    container.find('td.day.select').each(function(){
                        var date = $(this).attr('data-date');
                        if(daux === date) {
                            if(date !== lastw) {
                                $(this).click();
                                lastw = date;
                            }
                        }else
                            console.log(date + " " + daux);
                    });
                    $(this).remove();
                });
                sort_hiatus();
            });

            if($('#has_orders').val() !== '1') {
                container.find('td.day.select').bind('click', function () {
                    date = $(this).attr('data-date');
                    var au = date.split("-");
                    au = au[1] + " / " + au[2] + " / " + au[0];

                    if ($(this).closest('.days').hasClass('selected')) {
                        $.each($('td.day.select[data-date="' + date + '"]'), function () {
                            $(this).closest('.days').addClass('unselected').removeClass('selected');
                        });
                        $('input[name="campaign_weeks[]"][value="' + date + '"]').remove();
                        console.log("au2: " + au);
                        $("#hiatus_weeks").html($("#hiatus_weeks").html() + '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>');
                        var v = $("input:radio[name=flength]:checked").attr('value');
                        // if (v === 'd')
                        //     $("#weeks_count").val(calc_diff_days());
                        // else
                        //     $("#weeks_count").val(parseInt($("#weeks_count").val()) - 1);
                        sort_hiatus();
                    } else {
                        $.each($('td.day.select[data-date="' + date + '"]'), function () {
                            $(this).closest('.days').removeClass('unselected').addClass('selected');
                        });
                        $('#flight_weeks_inputs').append('<input type="hidden" name="campaign_weeks[]" value="' + date + '" value="true" />');

                        $('#hiatus_weeks option').each(function () {
                            if ($(this).val() === au) {
                                $(this).remove();
                                return;
                            }
                        });
                        var v = $("input:radio[name=flength]:checked").attr('value');
                        // if (v === 'd')
                        //     $("#weeks_count").val(calc_diff_days());
                        // else
                        //     $("#weeks_count").val(parseInt($("#weeks_count").val()) + 1);
                        sort_hiatus();
                    }
                });
            }
            first = 0;
        }

        $('#show_archive_campaigns').on('change', function (){
            if($("#report_advertisers").val().length > 0) {
                var show = $('#show_archive_campaigns').is(':checked');
                $("#report_campaigns option").each(function () {
                    if( $(this).attr('archive') > 0 && show === true)
                        $(this).removeClass('hidden');
                    else if( $(this).attr('archive') > 0 && show === false)
                        $(this).addClass('hidden')
                });
                console.log('report', $("#report_campaigns").html());
                $("#report_campaigns").multiSelect("refresh");

                $(".select_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("select_all").multiSelect('refresh');
                });
                $(".deselect_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("deselect_all").multiSelect('refresh');
                });
            }
        });



        $("#report_advertisers").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_advertisers-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_advertisers-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();
                var arr = [];
                $('#report_campaigns option:selected').each(function () {
                    arr.push($(this).attr('value'));
                });
                var arr_adv = [];
                $('#report_advertisers option:selected').each(function () {
                    arr_adv.push($(this).attr('value'));
                });
                var params = {
                    'data': arr_adv,
                    'camp': arr,
                    'start': $('#date_range_11').val(),
                    'end': $('#date_range_22').val(),
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/advertiser/smart_report/search-campaigns',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        var selected_ar = $("#report_campaigns").val();
                        console.log('selected_ar', selected_ar);
                        var html = '';
                        for (var i in response['campaigns_g']) {
                             html += '<optgroup id="adv_'+ i +'" label="'+ i.toUpperCase() +'">';
                             for(var ind in response['campaigns_g'][i]) {
                                 if (response['campaigns_g'][i][ind].deleted_at === null || response['campaigns_g'][i][ind].archive_year > 0) {
                                     var text = response['campaigns_g'][i][ind].archive_year > 0 ? ' (Archived) ' : '';
                                     var selected = selected_ar.indexOf(response['campaigns_g'][i][ind].id) !== -1 ? 'selected' : '';
                                     html += '<option ' + selected + ' archive="' + response['campaigns_g'][i][ind].archive_year + '" value="' + response['campaigns_g'][i][ind].id + '" >' + response['campaigns_g'][i][ind].name + ' ' + text + '</option>';
                                 }
                             }
                            html += '</optgroup>';
                        }

                        $("#report_campaigns").html(html).multiSelect("refresh");

                        //To SHOW or HIDE THE OPTION
                        var show = $('#show_archive_campaigns').is(':checked');

                        $("#report_campaigns option").each(function () {
                            if( $(this).attr('archive') > 0 && show === true)
                                $(this).removeClass('hidden');
                            else if( $(this).attr('archive') > 0 && show === false)
                                $(this).addClass('hidden')
                        });
                        $("#report_campaigns").multiSelect("refresh");

                        var html='';
                        for(var i in response['brands']){
                            html += '<option value="'+ response['brands'][i].slug +'">'+ response['brands'][i].name +'</option>';
                        }
                        $('#report_brands').html(html).multiSelect('refresh');

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            },
            afterDeselect: function(values){
                show_loader();
                $("#adv_" + values[0]).remove();
                $("#report_campaigns").multiSelect("refresh");
                $("#report_brands").multiSelect("refresh");
                $("#report_products").multiSelect("refresh");
                $(".select_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("select_all").multiSelect('refresh');
                });

                $(".ddeselect_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    console.log(id);
                    $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                    if(id == 'report_advertisers'){
                        $('#report_campaigns').html('').multiSelect('refresh');
                        $('#custom_markets').html('').multiSelect('refresh');
                        $('#dma_markets').html('').multiSelect('refresh');
                        $('#msa_markets').html('').multiSelect('refresh');
                        $('#report_brands').html('').multiSelect('refresh');
                        $('#report_products').html('').multiSelect('refresh');
                    }
                    else if(id == 'report_campaigns'){
                        $('#custom_markets').html('').multiSelect('refresh');
                        $('#dma_markets').html('').multiSelect('refresh');
                        $('#msa_markets').html('').multiSelect('refresh');
                        $('#report_brands').html('').multiSelect('refresh');
                        $('#report_products').html('').multiSelect('refresh');
                    }
                    else if(id =='report_brands')
                        $('#report_products').html('').multiSelect('refresh');
                });
                hide_loader();
            }
        });

        $("#report_campaigns").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_campaigns-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_campaigns-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();
                var params = {
                    'data': $('#report_campaigns').val()
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search-markets/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        console.log(response);

                        var html = '';
                        for(var i in response['msa']){
                            html += '<option value="'+ response['msa'][i].slug +'">'+ response['msa'][i].name +'</option>';
                        }
                        $("#msa_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['dma']){
                            html += '<option value="'+ response['dma'][i].slug +'">'+ response['dma'][i].name +'</option>';
                        }
                        $("#dma_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['custom']){
                            html += '<option value="'+ response['custom'][i].slug +'">'+ response['custom'][i].name +'</option>';
                        }
                        $("#custom_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['medias']){
                         //   var disabled = ($('#report_type').val() !== 'inv_isci_report' || response['medias'][i].name == 'tv' || response['medias'][i].name == 'radio') ? '' : 'disabled';
                            var disabled = ($('#report_type').val() === 'inv_isci_report' || $('#report_type').val() === 'invoiced_items') && (response['medias'][i].name !== 'tv' && response['medias'][i].name !== 'cable' && response['medias'][i].name !== 'radio') ? 'disabled' : '';

                            html += '<div class="checkbox-danger checkbox-inline checkbox " style="margin-left: 2%">' +
                                '           <input id="report_media_' + response['medias'][i].name + '" ' +
                                '           name="report_media_types[]" type="checkbox" value="' + response['medias'][i].name + '"  ' + disabled + '>' +
                                '           <label for="report_media_' + response['medias'][i].name + '"> ' + response['medias'][i].title + ' </label>' +
                                '                                                       </div>';
                        }
                        $(".report_media_types_div").html(html);

                        var html = '';
                        for(var i in response['brands']){
                            html += '<option value="'+ response['brands'][i].slug +'">'+ response['brands'][i].name +'</option>';
                        }
                        $("#report_brands").html(html).multiSelect("refresh");

                        $("#report_products").html('').multiSelect("refresh");

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            },
            afterDeselect: function(values){
                show_loader();
                var arr = $('#report_campaigns option:selected').map(function(){
                    return this.value
                }).get();
                console.log(arr);
                var params = {
                    'data': arr
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url:'/smart/reports/campaign/search-markets/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        console.log(response);

                        var html = '';
                        for(var i in response['msa']){
                            html += '<option value="'+ response['msa'][i].slug +'">'+ response['msa'][i].name +'</option>';
                        }
                        $("#msa_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['dma']){
                            html += '<option value="'+ response['dma'][i].slug +'">'+ response['dma'][i].name +'</option>';
                        }
                        $("#dma_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['custom']){
                            html += '<option value="'+ response['custom'][i].slug +'">'+ response['custom'][i].name +'</option>';
                        }
                        $("#custom_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['medias']){
                           // var disabled = ($('#report_type').val() !== 'inv_isci_report' || response['medias'][i].name == 'tv' || response['medias'][i].name == 'radio') ? '' : 'disabled';
                            var disabled = ($('#report_type').val() === 'inv_isci_report' || $('#report_type').val() === 'invoiced_items') && (response['medias'][i].name !== 'tv' && response['medias'][i].name !== 'cable' && response['medias'][i].name !== 'radio') ? 'disabled' : '';

                            html += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                '           <input id="report_media_' + response['medias'][i].name + '" ' +
                                '           name="report_media_types[]" type="checkbox" value="' + response['medias'][i].name + '"  ' + disabled + '>' +
                                '           <label for="report_media_' + response['medias'][i].name + '"> ' + response['medias'][i].title + ' </label>' +
                                '                                                       </div>';


                            //
                            // if($('#report_type').val() !== 'inv_isci_report')
                            //     html += '<option value="'+ response['medias'][i].name +'">'+ response['medias'][i].title +'</option>';
                            // else if(response['medias'][i].name === 'tv' || response['medias'][i].name === 'radio')
                            //     html += '<option value="'+ response['medias'][i].name +'">'+ response['medias'][i].title +'</option>';
                            // else
                            //     html += '<option value="'+ response['medias'][i].name +'" disabled>'+ response['medias'][i].title +'</option>';
                        }
                        $(".report_media_types_div").html(html);
                        // $('#report_media_types').select2({
                        //     placeholder: "Select at least one..",
                        //     closeOnSelect: false
                        // }).on('select2:unselecting', function (e) {
                        //
                        // }).on('select2:select', function (e) {
                        //
                        // });
                        var html = '';
                        for(var i in response['brands']){
                            html += '<option value="'+ response['brands'][i].slug +'">'+ response['brands'][i].name +'</option>';
                        }
                        $("#report_brands").html(html).multiSelect("refresh");

                        $("#report_products").html('').multiSelect("refresh");

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            }
        });

        $("#custom_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="custom_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='custom_details-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#display_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="display_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='display_details-deselect_all_det2'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#estimate_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="estimate_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='estimate_details-deselect_all_det3'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#approved_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="approved_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='approved_details-deselect_all_det4'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#dma_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="dma_markets-select_all_det1">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='dma_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#msa_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="msa_markets-select_all_det1">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='msa_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#custom_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="custom_markets-select_all_det1">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='custom_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        //
        // $('#report_media_types').select2({
        //     placeholder: "Select at least one..",
        //     closeOnSelect: false
        // }).on('select2:unselecting', function (e) {
        //     var id = e.params.args.data.id; //your id
        //
        // }).on('select2:select', function (e) {
        //
        // });

        $("#report_brands").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_brands-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_brands-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();

                var params = {
                    'data': $('#report_brands').val()
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        // var html='';
                        // for(var i in response['products']){
                        //     html += '<option value="'+ response['products'][i].slug +'">'+ response['products'][i].name +'</option>';
                        // }
                        // $("#report_products").html(html).multiSelect("refresh");
                        console.log('products response', response);
                        var prod_sel=[];
                        $('#report_products option:selected').each(function(){
                            prod_sel.push($(this).val());                        });

                        var html_prod ='';
                        for(var i in response['products']){
                            var ss='';
                            if(prod_sel.indexOf(response['products'][i].slug) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + response['products'][i].slug + '" '+ss+'> ' + response['products'][i].name + ' </option>';
                        };
                        $("#report_products").html(html_prod).multiSelect("refresh");

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            },
            afterDeselect: function(values){
                show_loader();

                var params = {
                    'data': $('#report_brands').val(),
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        // var html='';
                        // for(var i in response['products']){
                        //     html += '<option value="'+ response['products'][i].slug +'">'+ response['products'][i].name +'</option>';
                        // }
                        // $("#report_products").html(html).multiSelect("refresh");
                        console.log('products response', response);
                        var prod_sel=[];
                        $('#report_products option:selected').each(function(){
                            prod_sel.push($(this).val());                        });

                        var html_prod ='';
                        for(var i in response['products']){
                            var ss='';
                            if(prod_sel.indexOf(response['products'][i].slug) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + response['products'][i].slug + '" '+ss+'> ' + response['products'][i].name + ' </option>';
                        };
                        $("#report_products").html(html_prod).multiSelect("refresh");

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
                hide_loader();
            }
        });

        $("#report_products").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_products-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_products-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
            },
            afterDeselect: function(values){
            }
        });

        $(".direct_access_date").on("click", function(){
            var id = $(this).attr("id");
            var opt = $('input[name="calendar_type"]:checked').val();
            var day_no = moment().isoWeekday();
            console.log(id);
            console.log(opt);
            range_option_selected = id;
            if(opt === 'broadcast') {
                if (id === "month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") === month){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    $("#date_range_11").val(first);
                    $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "last_month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month){
                    }
                    var month1 = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month1){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") === month1){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");

                } else if (id === "6_month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    if(month < 7){
                        while(sunday.subtract(7, 'days').format("M") < 7){
                        }
                        var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                        sunday = sunday.add(6, 'days');
                        while(sunday.add(7, "days").format("M") < 7){
                        }
                        var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                        console.log(first+" / "+end);
                        // $("#date_range_11").val(first);
                        // $("#date_range_22").val(end);
                        $("#date_range_11").data('daterangepicker').setStartDate(first);
                        $("#date_range_22").data('daterangepicker').setStartDate(end);
                        $("#date_range_22").trigger("change");
                    }else{
                        while(sunday.subtract(7, 'days').format("M") > 7){
                        }
                        var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                        sunday = sunday.add(6, 'days');
                        while(sunday.add(7, "days").format("M") > 7){
                        }
                        var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                        console.log(first+" / "+end);
                        // $("#date_range_11").val(first);
                        // $("#date_range_22").val(end);
                        $("#date_range_11").data('daterangepicker').setStartDate(first);
                        $("#date_range_22").data('daterangepicker').setStartDate(end);
                        $("#date_range_22").trigger("change");
                    }
                } else if (id === "quarter") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    var from = 1;
                    var end = 4;
                    if(month < 4) {
                        from = 1;
                        end = 4;
                    }else if(month < 7) {
                        from = 3;
                        end = 7;
                    }else if(month < 10) {
                        from = 6;
                        end = 10;
                    }else {
                        from = 9;
                        end = 13;
                    }
                    while(sunday.subtract(7, 'days').format("M") > from && sunday.format("M") <= end){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") < end && sunday.format("M") >= from){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "year") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var year = sunday.format("YYYY");
                    while(sunday.subtract(7, 'days').format("YYYY") === year){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(363, 'days');
                    var end = sunday.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else { //last_year
                    var sunday = moment().add((7 - day_no), 'days');
                    var year = sunday.format("YYYY");
                    while(sunday.subtract(7, 'days').format("YYYY") >= year - 1){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(363, 'days');
                    var end = sunday.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                }
            }else{
                if (id === "month") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    // $("#date_range_11").val(month+"/01/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate(month+"/01/"+year);
                    var first = moment(month+"-01-"+year, "MM-DD-YYYY");
                    while(first.add(1, 'days').format("MM") === month){
                    }
                    var end = first.subtract(1, 'days').format("MM/DD/YYYY")
                    // $("#date_range_22").val(end);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "last_month") {
                    var today = moment();
                    var month1 = moment().format("MM");
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    if(month === "01"){
                        month = "12";
                        year = parseInt(year) - 1;
                    }else{
                        month = parseInt(month) - 1;
                    }
                    // $("#date_range_11").val(month+"/01/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate(month+"/01/"+year);
                    var first = moment(month+"-01-"+year, "M-DD-YYYY");
                    while(today.subtract(1, 'days').format("MM") === month1){
                    }
                    var end = today.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_22").val(end);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "6_month") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    if(parseInt(month) > 6){
                        // $("#date_range_11").val("06/01/"+year);
                        // $("#date_range_22").val("12/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("06/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    }else{
                        // $("#date_range_11").val("01/01/"+year);
                        // $("#date_range_22").val("06/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("06/30/"+year);
                    }
                    $("#date_range_22").trigger("change");
                } else if (id === "quarter") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    var intmonth = parseInt(month);
                    if(intmonth > 0 && intmonth < 4){
                        // $("#date_range_11").val("01/01/"+year);
                        // $("#date_range_22").val("03/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("03/31/"+year);
                    }else if(intmonth > 3 && intmonth < 7){
                        // $("#date_range_11").val("04/01/"+year);
                        // $("#date_range_22").val("06/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("04/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("06/30/"+year);
                    }else if(intmonth > 5 && intmonth < 10){
                        // $("#date_range_11").val("07/01/"+year);
                        // $("#date_range_22").val("09/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("07/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("09/30/"+year);
                    }else{
                        // $("#date_range_11").val("10/01/"+year);
                        // $("#date_range_22").val("12/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("10/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    }
                    $("#date_range_22").trigger("change");
                } else if (id === "year") {
                    var year = moment().format("YYYY");
                    // $("#date_range_11").val("01/01/"+year);
                    // $("#date_range_22").val("12/31/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                    $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    $("#date_range_22").trigger("change");
                } else { //last_year
                    var year = moment().format("YYYY");
                    year--;
                    // $("#date_range_11").val("01/01/"+year);
                    // $("#date_range_22").val("12/31/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                    $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    $("#date_range_22").trigger("change");
                }
            }
            fd_changed_in= 1;
        });

        $(".select_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            $('#'+id).multiSelect("select_all").multiSelect('refresh');
        });

        $(".ddeselect_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            console.log(id);
            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
            if(id == 'report_advertisers'){
                $('#report_campaigns').html('').multiSelect('refresh');
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id == 'report_campaigns'){
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id =='report_brands')
                $('#report_products').html('').multiSelect('refresh');
        });

    });
    $('#report_type').select2({
    }).on('select2:select', function (e) {
        $('#automate_report').hide();
      console.log('select2 e', e);
      $('#selected_report_div').html('<b>'+$('#report_type option:selected').html()+'</b>');


        $('.report_media_types_div input').each(function () {
            $(this).attr('disabled', false)
            $(this).prop('selected', false)
        });
      if($(this).val() !== 'inv_isci_report' && $(this).val() !== 'invoiced_items'){
          $('.report_media_types_div input').each(function () {
                $(this).attr('disabled', false)
                $(this).prop('selected', false)
          });

          $('.div_isci_code_hidden').hide();
      }
      else{
          $('.report_media_types_div input').each(function () {
              if($(this).val() == 'radio' || $(this).val() == 'tv' || $(this).val() == 'cable')
                 $(this).attr('disabled', false);
              else {
                  $(this).attr('disabled', true);
                  $(this).attr('selected', false)
              }
          });
          if($(this).val() !== 'inv_isci_report')
              $('.div_isci_code_hidden').hide();
          else
             $('.div_isci_code_hidden').show();
      }

      if($(this).val() =='inv_detail_report'){
          var html='';
          html+=' <option>Advertiser</option>' +
              '                                                                <option>Campaign</option>' +
              '                                                                <option>Brand</option>' +
              '                                                                <option>Product</option>' +
              '                                                                <option>Campaign Start Date</option>' +
              '                                                                <option>Campaign End Date</option>' +
              '                                                                <option>Camp. No.</option>' +
              '                                                                <option>Version Number</option>' +
              '                                                                <option>Market</option>\n' +
              '                                                                <option>Media Type</option>\n' +
              '                                                                <option>Vendor</option>\n' +
              '                                                                <option>Daypart</option>'+
              '                                                                <option>Length</option>'+
              '                                                                <option>Start Time</option>'+
              '                                                                <option>End Time</option>' +
              '                                                                <option>Programming</option>' +
              '                                                                <option>Order. No</option>'+
              '                                                                <option>Order Line</option>'+
              '                                                                <option>Order Transfer Date</option>'+
              '                                                                <option>Estimate No.</option>'+
              '                                                                <option>Job No.</option>'+
              '                                                                <option>Contract No.</option>'+
              '                                                                <option>Tag</option>'+
              '                                                                <option>Commercial ID</option>'+
              '                                                                <option>Network</option>'+
              '                                                                <option>Station Format</option>'+
              '                                                                <option>Cable Zone</option>'+
              '                                                                <option>Owner</option>'+
              '                                                                <option>Invoice No.</option>\n' +
              '                                                                <option>Demographics</option>\n' +
              '                                                                <option>Invoice Transfer Date</option>\n' +
              '                                                                <option>Accounting Order No.</option>' +
              '                                                                <option>Vendor ID</option>' +
              '                                                                <option>Vendor Pub/ID</option>'+
              '                                                                <option>Ad Date</option>'+
              '                                                                <option>Size</option>'+
              '                                                                <option>Issue/Vol</option>'+
              '                                                                <option>Comments</option>'
          ;
          $('#custom_details').html(html).multiSelect('refresh');
          $("#custom_details").html($("#custom_details option").sort(function(a, b) {
              return a.text == b.text ? 0 : a.text < b.text ? -1 : 1
          }))
          $('#custom_details').multiSelect('refresh');
          html='';
          html+='   <option>Ordered Ads</option>\n' +
              '                                                                <option>Ordered GRPs</option>\n' +
              '                                                                <option>Ordered GRIs</option>\n' +
              '                                                                <option>Ordered Gross Cost</option>\n' +
              '                                                                <option>Ordered Client Cost</option>\n' +
              '                                                                <option>Ordered Net Cost</option>\n' +
              '                                                                <option>Ordered Gross CPP</option>\n' +
              '                                                                <option>Ordered Net CPP</option>\n' +
              '                                                                <option>Ordered Gross CPM</option>\n' +
              '                                                                <option>Ordered Net CPM</option>\n' +
              '                                                                <option>Ordered Clicks</option>\n' +
              '                                                                <option>Ordered Cost per Click</option>\n' +
              // '                                                                <option>Avg. GRPs/Impressions</option>'+
              '                                                                <option>Approved Ads</option>'+
              '                                                                <option>Approved Impressions</option>'+
              '                                                                <option>Approved Gross Cost</option>'+
              '                                                                <option>Approved Net Cost</option>'+
              '                                                                <option>Approved GRPs</option>'+
              '                                                                <option>Approved GRIs</option>'+
              '                                                                <option>Date Aired</option>'+
              '                                                                <option>Time Aired</option>'+
              '                                                                <option>Length Aired</option>'+
              '                                                                <option>Day Aired</option>'+
              '                                                                <option>Spend Difference Gross</option>'+
              '                                                                <option>Spend Difference Net</option>'
          ;
          $('#estimate_details').html(html).multiSelect('refresh');
          $("#estimate_details").html($("#estimate_details option").sort(function(a, b) {
              return a.text == b.text ? 0 : a.text < b.text ? -1 : 1
          }))
          $('#estimate_details').multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
      else if($(this).val() =='inv_status_report') {
          $('#custom_details').html(html_custom_details.replace("<option>Demo</option>", "")).multiSelect('refresh');
          $('#estimate_details').html(html_estimate_details.replace("<option>GRIs</option>", "")).multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
      else if($(this).val() == 'client_activity_report'){
         $('.div_custom_details').hide();
         $('.div_activity_report').show();
          html +=  '                                                           <option>Ads </option>' +
              '                                                                <option>Gross Cost</option>' +
              '                                                                <option>Net Cost</option>' +
              '                                                                <option>Client Cost</option>' +
              '                                                                <option>Client Gross (WMJ)</option>' +
              '                                                                <option>GRP</option>' +
              '                                                                <option>GRI</option>' +
              '                                                                <option>CPP</option>' +
              '                                                                <option>Net CPP</option>' +
              '                                                                <option>CPM</option>' +
              '                                                                <option>Net CPM</option>'+
              '                                                                <option>Clicks</option>'+
              '                                                                <option>Cost per Clicks</option>'
          ;
          $('#estimate_details').html(html).multiSelect('refresh');
          $("#estimate_details").html($("#estimate_details option").sort(function(a, b) {
              return a.text == b.text ? 0 : a.text < b.text ? -1 : 1
          }))
          $('#estimate_details').multiSelect('refresh');

      }
      else if($(this).val() == 'inv_isci_report') {
          html = '';
          html += '<option>Advertiser</option>';
          html += '<option>Brand</option>';
          html += '<option>Campaign</option>';
          html += '<option>Campaign Start Date</option>';
          html += '<option>Campaign End Date</option>';
          html += '<option>Camp. No.</option>';
          html += '<option>Commercial Code</option>';
          html += '<option>Day of Week</option>';
          html += '<option>Estimate No.</option>';
          html += '<option>Job No.</option>';
          html += '<option>Invoice Number</option>';
          html += '<option>Length</option>';
          html += '<option>Market</option>';
          html += '<option>Media Type</option>';
          html += '<option>Product</option>';
          html += '<option>Run Date</option>';
          html += '<option>Run Time</option>';
          html += '<option>Status</option>';
          html += '<option>Vendor</option>';
          $('#custom_details').html(html).multiSelect('refresh');
          html = '';
          html += '<option>Ads</option>';
          html += '<option>Approval Rate</option>';
          html += '<option>Net Approval Rate</option>';
          $('#estimate_details').html(html).multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
      else if($(this).val() == 'traffic_report') {
          html = '';
          html += '<option>Advertiser</option>';
          html += '<option>Campaign</option>';
          html += '<option>Campaign Start Date</option>';
          html += '<option>Campaign End Date</option>';
          html += '<option>Media Type</option>';
          html += '<option>Market</option>';
          html += '<option>Format</option>';
          html += '<option>File Size</option>';
          html += '<option>File Format</option>';
          html += '<option>Traffic Instructions</option>';
          html += '<option>Material Closing Date</option>';
          html += '<option>Space Closing Date</option>';
          html += '<option>Specifications</option>';
          html += '<option>Targeting</option>';
          html += '<option>Comments</option>';
          $('#custom_details').html(html).multiSelect('refresh');
          html = '';
          html += '<option>Ads/Units</option>';
          html += '<option>Cost</option>';
          html += '<option>Commercial Code</option>';
          html += '<option>Length</option>';
          html += '<option>Traffic Period</option>';
          html += '<option value="Percent">Ordered Percent</option>';
          html += '<option>Invoiced Percent</option>';

          $('#estimate_details').html(html).multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
      else if($(this).val() =='mediastruction_report') {
          $('#automate_report').show();
          html = '';
          html += ' <option selected>Impressions</option><option selected>Total Cost (Net)</option>';
          $('#estimate_details').html(html).multiSelect('refresh');

          html = '';
          html += ' <option selected>Advertiser</option><option selected>Campaign</option>';
          html += ' <option selected>Media Type</option><option selected>Date</option>';
          $('#custom_details').html(html).multiSelect('refresh');
      }
      else if($(this).val() == 'invoiced_items') {
          html = '';
          html += '<option>Advertiser</option>';
          html += '<option>Campaign</option>';
          html += '<option selected>Station</option>';
          html += '<option selected>Type</option>';
          html += '<option selected >Zone</option>';
          html += '<option selected >Network</option>';
          html += '<option>Program</option>';
          html += '<option selected>ISCI</option>';
          html += '<option>Air Date</option>';
          html += '<option>Air Time</option>';
          html += '<option>Length</option>';
          html += '<option>Invoice Number</option>';
          html += '<option>Invoice Type</option>';
          $('#custom_details').html(html).multiSelect('refresh');
          html = '';
          html += '<option selected>Spot Price</option>';
          $('#estimate_details').html(html).multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
      else {
          $('#custom_details').html(html_custom_details).multiSelect('refresh');
          $('#estimate_details').html(html_estimate_details).multiSelect('refresh');
          $('.div_custom_details').show();
          $('.div_activity_report').hide();
      }
        //Automate button code
        if($(this).val() !== 'mediastruction_report') {
            $('#automate_report').hide();
            $('#automate_report_hidden').val(false);

            $('#date_range_11').val(moment().format('MM/DD/YYYY'))
            $('#date_range_22').val(moment().add(5, 'w').format('MM/DD/YYYY'))
            $('#date_range_11').trigger('change')
            $('#date_range_22').trigger('change')

            $('.direct_access_date_div').show();
            $('.flight_weeks_container_div').show();
            $('#date_range_22').show();


            $('.automate_period_div').hide();
            $('#monthly_monthly_div').hide();
            $('.send_email_to_aut').hide();
        }
        $(".select_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            $('#'+id+"").multiSelect("select_all").multiSelect('refresh');

        });

        $(".ddeselect_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            $('#'+id+"").multiSelect('deselect_all').multiSelect('refresh');
            if(id == 'report_advertisers'){
                $('#report_campaigns').html('').multiSelect('refresh');
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id == 'report_campaigns'){
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id =='report_brands')
                $('#report_products').html('').multiSelect('refresh');
        });

    });

    $('#automate_report').on('click', function () {
        $('#automate_report_hidden').val(true);
        //Hide
        $('.direct_access_date_div').hide();
        $('.flight_weeks_container_div').hide();
        $('#date_range_22').hide();

        $('#date_range_11').val(moment().format('MM/DD/YYYY'))
        $('#date_range_11').daterangepicker({
            "showWeekNumbers": false,
            "singleDatePicker": true,
            "startDate": moment(),
            "minDate": moment(),
        });

        $('#date_range_22').val(moment().add(2, 'y').format('MM/DD/YYYY'))
        $('#date_range_11').trigger('change')
        $('#date_range_22').trigger('change')

        //Show
        $('.automate_period_div').show();
        $('#monthly_monthly_div').show();
        $('.send_email_to_aut').show();


        change_automate_period();

    });
    $('.automate_period_div input[type=radio]').on('change', function () {
        change_automate_period();
    });

    function change_automate_period(){
        if($("input:radio[name=time_frame]:checked").attr('value')  === 'weekly'){
            var quarter = [];
            var i = 1;
            var weeks = 54;
            while(i < weeks) {
                quarter.push({'id': i, 'text': i});
                i++;
            }
            $('#monthly_monthly').html('').select2({
                'data': quarter,
                 closeOnSelect: true
            });
            $('#monthly_monthly_div').show();
        }
        else
            $('#monthly_monthly_div').hide();
    }

    function ValidateEmail(mail)
    {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(myForm.emailAddr.value))
        {
            return (true)
        }
        alert("You have entered an invalid email address!")
        return (false)
    }

};


if($("#smart-report-form-update").length){
    $('#selected_report_div').html('<b>'+$('#report_type option:selected').html()+'</b>');

    form_wizard('#smart-report-form-wizard',
        {
            'report_advertisers[]': {
                required: true
            },
            "report_campaigns[]": {
                required: true
            },
            "report_media_types[]": {
                required: true
            },
            "display_details[]": {
                required: true
            },
            "custom_details[]": {
                required: true
            },
            "estimate_details[]": {
                required: true
            },
        },
        {
            "display_details[]": "Please choose at least one display option.",
            "report_media_types[]": "Please choose at least one media type.",
            "report_campaigns[]": "Please choose at least one campaign.",
            "report_advertisers[]": "Please choose at least one advertiser.",
            "custom_details[]": "Please choose at least one custom detail.",
            "estimate_details[]": "Please choose at least one estimate detail.",

        }
    );
    $('#smart-previous').on('click', function () {
        if ($('.form_wizard .custom-tabs li.active').attr('id') == 2)
            active_start();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 3)
            active_adv_camp();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 4)
            active_brand_prod();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 5)
            active_media_market();
    });
    $('.wizard-active-start').on('click', function () {
        active_start();
    });
    $('.wizard-active-adv-camp').on('click', function () {
        active_adv_camp();
    });
    $('.wizard-active-brand-prod').on('click', function () {
        active_brand_prod();
    });
    $('.wizard-active-media-markets').on('click', function () {
        active_media_market();
    });
    $('.wizard-active-details').on('click', function () {
        active_details();
    });
    $('#smart-next').on('click', function () {
        if ($('.form_wizard .custom-tabs li.active').attr('id') == 1)
            active_adv_camp();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 2)
            active_brand_prod();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 3)
            active_media_market();
        else if ($('.form_wizard .custom-tabs li.active').attr('id') == 4)
            active_details();
    });
    var active_start = function (){
        if ($('#tab2').hasClass('active'))
            $('.wizard-active-adv-camp').removeAttr('aria-expanded');
        if ($('#tab3').hasClass('active'))
            $('.wizard-active-brand-prod').removeAttr('aria-expanded');
        if ($('#tab4').hasClass('active'))
            $('.wizard-active-media-markets').removeAttr('aria-expanded');
        if ($('#tab5').hasClass('active'))
            $('.wizard-active-details').removeAttr('aria-expanded');

        active_clean_all();
        $('#tab1').addClass('active');
        $('#tab1').addClass('content-current');
        $('.li_1').addClass('tab-current');
        $('.li_1').addClass('active');
        $('.wizard-active-start').attr('aria-expanded', true);
        $('#smart-next').css('display', 'inline');
    };
    var active_adv_camp = function () {
        if ($('#tab1').hasClass('active'))
            $('.wizard-active-start').removeAttr('aria-expanded');
        if ($('#tab3').hasClass('active'))
            $('.wizard-active-brand-prod').removeAttr('aria-expanded');
        if ($('#tab4').hasClass('active'))
            $('.wizard-active-media-markets').removeAttr('aria-expanded');
        if ($('#tab5').hasClass('active'))
            $('.wizard-active-details').removeAttr('aria-expanded');

        active_clean_all();
        $('#tab2').addClass('active');
        $('#tab2').addClass('content-current');
        $('.li_2').addClass('tab-current');
        $('.li_2').addClass('active');
        $('.wizard-active-adv-camp').attr('aria-expanded', true);
        $('#smart-next').css('display', 'inline');
        $('#smart-previous').css('display', 'inline');
    };
    var active_brand_prod =  function () {
        if( $('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.' + ' \n';
            var $validator = form_validator('#smart-report-form-update');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab4').hasClass('active'))
                $('.wizard-active-media-markets').removeAttr('aria-expanded');
            if ($('#tab5').hasClass('active'))
                $('.wizard-active-details').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab3').addClass('active');
            $('#tab3').addClass('content-current');
            $('.li_3').addClass('tab-current');
            $('.li_3').addClass('active');
            $('.wizard-active-adv-camp').attr('aria-expanded', true);
            $('#smart-next').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_media_market = function () {
        if( $('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.' + ' \n';

            var $validator = form_validator('#smart-report-form-update');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab3').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab5').hasClass('active'))
                $('.wizard-active-details').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab4').addClass('active');
            $('#tab4').addClass('content-current');
            $('.li_4').addClass('tab-current');
            $('.li_4').addClass('active');
            $('.wizard-active-media-markets').attr('aria-expanded', true);
            $('#smart-next').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_details = function () {
        if($('#tab2').hasClass('active') && ($('#report_advertisers').val().length == 0 || $('#report_campaigns').val().length == 0)) {
            var text = '';
            if($('#report_advertisers').val().length == 0)
                text += 'Select at least one advertiser.' + ' \n';
            if($('#report_campaigns').val().length == 0)
                text += 'Select at least one campaign.' + ' \n';
            var $validator = form_validator('#smart-report-form-wizard');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else if($('#tab4').hasClass('active')  && ($(".report_media_types_div input:checked").length == 0 || ($('#dma_markets').val().length == 0 && $('#msa_markets').val().length == 0 && $('#custom_markets').val().length == 0))) {
            var text = '';
            if($(".report_media_types_div input:checked").length == 0)
                text += 'Select at least one media type.' + ' \n';
            if($('#dma_markets').val().length == 0 && $('#msa_markets').val().length == 0 && $('#custom_markets').val().length == 0)
                text += 'Select at least one market.' + ' \n';

            var $validator = form_validator('#smart-report-form-wizard');
            $validator.focusInvalid();
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });

        }
        else {
            if ($('#tab1').hasClass('active'))
                $('.wizard-active-start').removeAttr('aria-expanded');
            if ($('#tab2').hasClass('active'))
                $('.wizard-active-adv-camp').removeAttr('aria-expanded');
            if ($('#tab4').hasClass('active'))
                $('.wizard-active-media-markets').removeAttr('aria-expanded');
            if ($('#tab3').hasClass('active'))
                $('.wizard-active-brand-prod').removeAttr('aria-expanded');

            active_clean_all();
            $('#tab5').addClass('active');
            $('#tab5').addClass('content-current');
            $('.li_5').addClass('tab-current');
            $('.li_5').addClass('active');
            $('.wizard-active-details').attr('aria-expanded', true);
            $('#smart-finish').css('display', 'inline');
            $('#smart-previous').css('display', 'inline');
        }
    };
    var active_clean_all  = function (){
        //clean tabs content
        $('#tab1').removeClass('active');
        $('#tab1').removeClass('content-current');
        $('#tab2').removeClass('active');
        $('#tab2').removeClass('content-current');
        $('#tab3').removeClass('active');
        $('#tab3').removeClass('content-current');
        $('#tab4').removeClass('active');
        $('#tab4').removeClass('content-current');
        $('#tab5').removeClass('active');
        $('#tab5').removeClass('content-current');

        //clean the list
        $('.li_1').removeClass('active');
        $('.li_1').removeClass('tab-current');
        $('.li_2').removeClass('active');
        $('.li_2').removeClass('tab-current');
        $('.li_3').removeClass('active');
        $('.li_3').removeClass('tab-current');
        $('.li_4').removeClass('active');
        $('.li_4').removeClass('tab-current');
        $('.li_5').removeClass('active');
        $('.li_5').removeClass('tab-current');

        //hide bottons
        $('#smart-previous').css('display', 'none');
        $('#smart-next').css('display', 'none');
        $('#smart-finish').css('display', 'none');
    };
    $('#smart-finish').on('click', function(){
        if($('#smart-report-form-update').valid()){
            if($('#automate_report_hidden').val() === 'true' || $('#automate_report_hidden').val() === true || $('#automate_report_hidden').val() === 1){
                if($('#email_to_aut').val() === ''){
                    swal({
                            title: "Oops!",
                            text: "You have chosen to automate this report, the email to send it is required.",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {


                    });
                }
                else {
                    swal({
                            title: "Oops!",
                            text: "You have chosen to automate this report on an " + $("input:radio[name=time_frame]:checked").attr('value').toUpperCase() + " cadence. It will be sent to " + $('#email_to_aut').val() + ".",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm)
                                $('#smart-report-form-update').submit();

                        });
                }
            }
            else
                $('#smart-report-form-update').submit();
        }


    });



    $(document).ready(function () {
        var  fd_changed_in = 0;

        var df, dt, arr_df, arr_dt = '';
        if ($("#update_date_from").val() != ""){
            arr_df = $("#update_date_from").val().split(' ')[0].split('-');
            df = arr_df[1] + '/' + arr_df[2] + '/' + arr_df[0];
            arr_dt = $("#update_date_to").val().split(' ')[0].split('-');
            dt = arr_dt[1] + '/' + arr_dt[2] + '/' + arr_dt[0];
        }

        $("#daterange-input-container-11 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });

        var date_flag_value = ""

        $("#daterange-input-container-22 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });

        $('#daterange-input-container-11 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            "startDate": (df == undefined) ? moment().day(8) : df,
            //"endDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            "autoApply": true,
            "dateLimit": {
                "weeks": 53
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        });
        $('#daterange-input-container-22 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            //"startDate": (df == undefined) ? moment().day(8) : df,
            "startDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            //"minDate" : $("#date_range_1").val(),
            "autoApply": true,
            "dateLimit": {
                "weeks": 53
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        });

        if (df !== '' && typeof df !== 'undefined' && typeof df !== undefined && df !== null) {
            //$("#flight_dates_date_range").hide();
            showCalendar(true,true,$('input[name="calendar_type"]:checked').val());
            console.log("false1");
        } else {
            $('#flight_weeks_container').html('<div class="help-text text-center">Please input a Date Range to set this Campaign\'s Flight Weeks.</div>');
            //$('#flight_weeks_inputs').html('');
            showCalendar(true,true,$('input[name="calendar_type"]:checked').val());
            console.log("true1");
        }

        $("#date_range_11").on('click', function() {
            range_option_selected = null;
        });

        $("#date_range_22").on('click', function() {
            range_option_selected = null;
        });

        $("#date_range_11").on('change', function() {
            console.log("#date_range_11", $(this).val(), $("#date_range_22").val(), date_flag_value)
            if (date_flag_value !== $(this).val() && lchange == 0){
                if (moment($(this).val(), "MM/DD/YYYY") > moment($("#date_range_22").val(), "MM/DD/YYYY")) {
                    $('#date_range_22').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_22").val(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY")).trigger("change")
                } else if ($('#has_orders').val() !== '1') {
                    console.log("true2");
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true, false, $('input[name="calendar_type"]:checked').val());
                } else {
                    console.log("false1");
                }
                fd_changed_in=1
             }
        });
        $("#date_range_22").on('change', function(){
            console.log("#date_range_22",$("#date_range_11").val(), $(this).val(), date_flag_value)
            if(date_flag_value !== $(this).val() && lchange == 0) {
                if (moment($("#date_range_11").val(), "MM/DD/YYYY") > moment($(this).val(), "MM/DD/YYYY")) {
                    $('#date_range_11').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_11").val(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY")).trigger("change")
                } else if ($('#has_orders').val() !== '1') {
                    console.log("true2");
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true, false, $('input[name="calendar_type"]:checked').val());
                } else {
                    console.log("false2");
                }
                fd_changed_in=1
            }
        });
        $('.wizard-next-report').on('click', function () {
            console.log('has Active class', $('#tab1').hasClass('active'));
            console.log('fd_changed_in', fd_changed_in);
            if(fd_changed_in == 1 )
                reload_advertisers();
            fd_changed_in=0;
        });
        $('.wizard-active-adv-camp').on('click', function () {
            if(fd_changed_in == 1 )
                reload_advertisers();
            fd_changed_in=0;
        });
        var  reload_advertisers = function () {
            show_loader();
            var params= {
                start:  $("#date_range_11").val(),
                end:  $("#date_range_22").val(),
                camp_sel: $("#report_campaigns").val(),
                brand_sel: $("#report_brands").val(),
            }
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/smart/report/reload/advertisers',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('reload advertiser response', data);
                    var adv_sel=[];
                    $('#report_advertisers option:selected').each(function(){
                        adv_sel.push($(this).val());
                    });
                    var camp_sel=[];
                    $('#report_campaigns option:selected').each(function(){
                        camp_sel.push(parseInt($(this).val()));
                    });

                    var brand_sel=[];
                    $('#report_brands option:selected').each(function(){
                        brand_sel.push($(this).val());
                    });

                    var prod_sel=[];
                    $('#report_products option:selected').each(function(){
                        prod_sel.push($(this).val());
                    });
                    var market_dma=[];
                    $('#dma_markets option:selected').each(function(){
                        market_dma.push($(this).val());
                    });
                    var market_msa=[];
                    $('#msa_markets option:selected').each(function(){
                        market_msa.push($(this).val());
                    });
                    var market_custom=[];
                    $('#custom_markets option:selected').each(function(){
                        market_custom.push($(this).val());
                    });
                    var medias_sel=[];
                    $('#report_media_types input:checked').each(function(){
                        medias_sel.push($(this).val());
                    });
                    console.log('medias_sel', medias_sel);

                    var html= '';
                    var a_s=[];
                    var a_sx=[];
                    for(var i in data['adv']) {
                        var ss='';
                        if(adv_sel.indexOf(data['adv'][i].slug) !==-1) {
                            ss = 'selected';
                            a_s.push(data['adv'][i].slug);
                            a_sx.push(data['adv'][i].name);
                        }
                        html += '<option value="' + data['adv'][i].slug + '" '+ss+'>' + data['adv'][i].name + '</option>';
                    }
                    $('#report_advertisers').html(html).multiSelect('refresh');
                    var brand_options=[];
                    var html_cam='';
                    var camp_final_selected=[];
                    for(var i in a_s){
                        if(typeof data['camp'][a_s[i]] !== 'undefined'){
                            html_cam += '<optgroup id="adv_'+ a_s[i] +'" label="'+ a_sx[i].toUpperCase() +'">';
                            for(var x in data['camp'][a_s[i]]){
                                if(data['camp'][a_s[i]][x].deleted_at === null || data['camp'][a_s[i]][x].archive_year > 0) {
                                    var ss = '';
                                    console.log('x  ', data['camp'][a_s[i]][x].id);
                                    if (camp_sel.indexOf(data['camp'][a_s[i]][x].id) !== -1) {
                                        ss = 'selected';
                                        if (typeof data['brands'][data['camp'][a_s[i]][x].id] !== 'undefined')
                                            brand_options.push(data['brands'][data['camp'][a_s[i]][x].id]);
                                        camp_final_selected.push(data['camp'][a_s[i]][x].id);
                                    }

                                    html_cam += '<option value="' + data['camp'][a_s[i]][x].id + '" ' + ss + '>' + data['camp'][a_s[i]][x].name + '</option>';
                                }
                            }
                            html_cam += '</optgroup>';
                        }
                    }

                    $('#report_campaigns').html(html_cam).multiSelect('refresh');

                    var html_brands=[];
                    var product_options=[];
                    $('#report_brands option').each(function(){
                        if(brand_options.indexOf($(this).attr('value')) !==-1) {
                            var ss='';
                            if(brand_sel.indexOf($(this).attr('value')) !==-1) {
                                ss = 'selected';
                                if(typeof data['products'][$(this).attr('value')] !== 'undefined') {
                                    for(var i in data['products'][$(this).attr('value')])
                                        product_options.push(data['products'][$(this).attr('value')][i]);
                                }
                            }
                            html_brands += '<option value="' + $(this).attr('value') + '" '+ss+'> ' + $(this).html() + ' </option>';
                        }
                    });

                    $('#report_brands').html(html_brands).multiSelect('refresh');

                    var html_prod='';
                    $('#report_products option').each(function(){
                        if(product_options.indexOf($(this).attr('value')) !==-1) {
                            var ss='';
                            if(prod_sel.indexOf($(this).attr('value')) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + $(this).attr('value') + '" '+ss+'> ' + $(this).html() + ' </option>';
                        }
                    });
                    $('#report_products').html(html_prod).multiSelect('refresh');

                    var html_dma='';
                    var html_msa='';
                    var html_custom='';
                    console.log('camp_final_selected', camp_final_selected);
                    console.log('data[markets]', data['markets']);
                    var market_added = [];
                    for(var c in camp_final_selected){
                        var m = camp_final_selected[c];
                        if(typeof data['markets'][m] !== 'undefined'){
                            for(var y in data['markets'][m]){
                                if(market_added.indexOf(data['markets'][m][y].slug) === - 1) {
                                    if (data['markets'][m][y].type == 'dma') {
                                        var ss = '';
                                        if (market_dma.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_dma += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    } else if (data['markets'][m][y].type == 'msa') {
                                        var ss = '';
                                        if (market_msa.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_msa += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    } else {
                                        var ss = '';
                                        if (market_custom.indexOf(data['markets'][m][y].slug) !== -1)
                                            ss = 'selected';
                                        html_custom += '<option value="' + data['markets'][m][y].slug + '" ' + ss + '> ' + data['markets'][m][y].name + ' </option>';
                                    }
                                    market_added.push(data['markets'][m][y].slug);
                                }
                            }
                        }
                    }
                    $('#custom_markets').html(html_custom).multiSelect('refresh');
                    $('#dma_markets').html(html_dma).multiSelect('refresh');
                    $('#msa_markets').html(html_msa).multiSelect('refresh');

                    var html_media='';
                    var media_type_added = [];
                    for(var c in camp_final_selected){
                        var m = camp_final_selected[c];
                        if(typeof data['medias'][m] !== 'undefined'){
                            for(var y in data['medias'][m]){
                                if(media_type_added.indexOf(data['medias'][m][y].title) === -1) {
                                    media_type_added.push(data['medias'][m][y].title);
                                    var ss = (medias_sel.indexOf(data['medias'][m][y].name) !== -1) ? 'checked' : '';
                                    var disabled = ($('#report_type').val() === 'inv_isci_report' || $('#report_type').val() === 'invoiced_items') && (data['medias'][m][y].name !== 'tv' && data['medias'][m][y].name !== 'cable' && data['medias'][m][y].name !== 'radio') ? 'disabled' : '';
                                    html_media += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                        '           <input id="report_media_' + data['medias'][m][y].name + '" ' +
                                        '           name="report_media_types[]" type="checkbox" '+ disabled +' value="' + data['medias'][m][y].name + '" ' + ss + '>' +
                                        '           <label for="report_media_' + data['medias'][m][y].name + '"> ' + data['medias'][m][y].title + ' </label>' +
                                        '                                                       </div>';
                                    if(data['medias'][m][y].name === 'tv' && media_type_added.indexOf('cable') === -1){
                                        var ss = (medias_sel.indexOf('cable') !== -1) ? 'checked' : '';
                                        html_media += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                            '           <input id="report_media_cable" ' +
                                            '           name="report_media_types[]" type="checkbox" '+ disabled +' value="cable" ' + ss + '>' +
                                            '           <label for="report_media_cable"> Cable </label>' +
                                            '                                                       </div>';
                                    }
                                }
                            }
                        }
                    }
                    $('.report_media_types_div').html(html_media);

                    $(".select_all_reports").on("click", function(){
                        var id = $(this).attr("id").split("-")[0];
                        $('#'+id+"").multiSelect("select_all").multiSelect('refresh');
                    });

                    $(".ddeselect_all_reports").on("click", function(){
                        var id = $(this).attr("id").split("-")[0];
                        $('#'+id+"").multiSelect('deselect_all').multiSelect('refresh');
                        if(id == 'report_advertisers'){
                            $('#report_campaigns').html('').multiSelect('refresh');
                            $('#custom_markets').html('').multiSelect('refresh');
                            $('#dma_markets').html('').multiSelect('refresh');
                            $('#msa_markets').html('').multiSelect('refresh');
                            $('#report_brands').html('').multiSelect('refresh');
                            $('#report_products').html('').multiSelect('refresh');
                        }
                        else if(id == 'report_campaigns'){
                            $('#custom_markets').html('').multiSelect('refresh');
                            $('#dma_markets').html('').multiSelect('refresh');
                            $('#msa_markets').html('').multiSelect('refresh');
                            $('#report_brands').html('').multiSelect('refresh');
                            $('#report_products').html('').multiSelect('refresh');
                        }
                        else if(id =='report_brands')
                            $('#report_products').html('').multiSelect('refresh');
                    });
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });
        };

        var flight_dates_date_range;
        var start_date;
        var end_date;

        /*$("#weeks_count").on("focusin",function(){
            $(this).data('val',$(this).val())
        }).on("change", function(){
            if($('#has_orders').val() !== '1') {
                var v = parseInt($("#weeks_count").val());
                if (v > 0) {
                    lchange = 1;
                    console.log("new: " + v);
                    // var interv = $("#date_range").val();
                    // interv = interv.split(" - ");
                    var interv = [$('#date_range_11').val(), $('#date_range_22').val()]
                    var start = moment(interv[0], "MM/DD/YYYY");
                    var end = moment(interv[1], "MM/DD/YYYY");
                    var va = $("input:radio[name=flength]:checked").attr('value');
                    var unvisible_weeks = $("#hiatus_weeks option").sort(function(a,b){return new Date(b.value) - new Date(a.value);});
                    var start = moment(interv[0], "MM/DD/YYYY");

                    var aux = start.clone();
                    if (va === "d") {
                        aux.add(v - 1 , 'days');
                    } else {
                        aux.add((v * 7) - 1, 'days');
                    }
                    console.log(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                    //$("#date_range").val(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                    $('#date_range_11').val(start.format("MM/DD/YYYY"))
                    $('#date_range_22').val(aux.format("MM/DD/YYYY"))
                    $('#date_range_11').data('daterangepicker').setStartDate(start.format("MM/DD/YYYY"))
                    $('#date_range_22').data('daterangepicker').setStartDate(aux.format("MM/DD/YYYY"))
                    $("#flight_weeks_inputs").html('');
                    showCalendar(true,true,$('input[name="calendar_type"]:checked').val());
                    lchange = 0;

                    //return end.diff(start, 'days');
                } else {
                    global_notification('warning', 'Incorrect number of flight weeks ... ');
                    $("#weeks_count").val("0");
                }
            }
        });*/

        /*$(".flength_w").on('click', function(){
            console.log("in");
            var v = $("input:radio[name=flength]:checked").attr('value');
            if(v === 'w'){
                console.log("last w: " + last);
                if(last === "" || last === "d") {
                    last = v;
                    var au = parseInt($("#weeks_count").val());
                    console.log((au / 7).toFixed(0));
                    $("#weeks_count").val(Math.ceil(au/7));
                    //$("#weeks_count").val($("#flight_weeks_inputs input").length);
                }
            }
        });*/
        /*$(".flength_d").on('click', function(){
            console.log("in");
            var v = $("input:radio[name=flength]:checked").attr('value');
            if(v === 'd') {
                console.log("last d: " + last);
                if(last === "" || last === "w") {
                    last = v;
                    $("#weeks_count").val(calc_diff_days());
                }
            }
        });*/

        $('input[name="calendar_type"]').on("click",function(){
            if(range_option_selected !== null){
                $('#'+range_option_selected).click();
            }
            showCalendar(true,true,$(this).val())
        });

        function showCalendar(b,flag = false,calendar_type = "weeks"){
            var hiatus_weeks = $("#hiatus_weeks option").map(function(x) { return $("#hiatus_weeks option")[x].value.replace(new RegExp(' ','g'),""); }).toArray();
            $("#hiatus_weeks").html("");
            //temp = $('#date_range').val().split(" - ");
            temp = [$('#date_range_11').val(), $('#date_range_22').val()]

            start_date = moment(temp[0], 'MM/DD/YYYY');
            end_date = moment(temp[1], 'MM/DD/YYYY');

            var months = [];
            temp_start = moment(temp[0], 'MM/DD/YYYY');

            while(true){
                months.push([temp_start.format('M'), temp_start.format('YYYY')]);
                temp_start.add(1, 'month');
                if(temp_start.isAfter(moment(end_date).add(1, 'month').date(1))){
                    break;
                }
            }
            if(months.length <= 3) {
                auxm = 200;
            }else{
                if(months.length % 3 === 0){
                    auxm = (months.length/3) * 200;
                }else{
                    auxm = ((months.length/3).toFixed(0) + 1) * 200;
                }
            }
            cheight = 0;

            var weeks = [];
            temp_start = moment(temp[0], 'MM/DD/YYYY');
            var auxWeekYers = {};
            console.log()
            while(true){
                let weekNumber = temp_start.week();
                if (temp_start.weekday() === 0) {
                    weekNumber = temp_start.week() - 1;
                }
                if(typeof auxWeekYers[weekNumber + '' + temp_start.year()] === "undefined") {
                    console.log('temp_start_temp_start ', temp_start.format('MM/DD/YYYY'), weekNumber);
                    auxWeekYers[weekNumber + '' + temp_start.year()] = [weekNumber, temp_start.year()]
                    weeks.push({
                        week: weekNumber,
                        year: temp_start.year()
                    });
                }
                //temp_start.add(1, 'week');
                temp_start.add(1, 'days');
                if(temp_start.isSameOrAfter(moment(end_date).add(1, 'day'))){
                    break;
                }
            }
            var v = $("input:radio[name=flength]:checked").attr('value');

            weeks = collect(weeks);

            var container = $('#flight_weeks_container');
            container.html('');

            var inputs_container = $('#flight_weeks_inputs');
            var validate_fufllfill = $("#flight_weeks_inputs input").length;
            //inputs_container.html('');

            var month_count = 0;

            if(calendar_type !== "weeks" && months.length > 1 && moment(temp[0], 'MM/DD/YYYY').isoWeek() === moment().seconds(0).minutes(0).hours(0).date(1).month(parseInt(months[1][0]) - 1).year(months[1][1]).isoWeek())
                months.splice(0, 1);

            $.each(months, function(index, value){
                month_count++;

                var html = '';

                if((month_count % 3) === 0){
                    html += '<div class="row">';
                }

                var month_start = moment()
                    .seconds(0)
                    .minutes(0)
                    .hours(0)
                    .date(1)
                    .month(parseInt(value[0]) - 1)
                    .year(value[1]);

                html += '<div class="col-md-4 m-b-10" style="min-width: 300px"><div class="flight-date-calendar"><div class="calendar-wrapper"><table><tbody><tr class="heading"><td colspan="2" class="first"></td><td colspan="7"><div class="month">' + month_start.format('MMM YYYY') + '</div></td></tr><tr class="weekday"><td class="first">&nbsp;</td><td>#</td><td>M</td><td>T</td><td>W</td><td>R</td><td>F</td><td>S</td><td>U</td></tr>';

                calendar_start = moment(month_start).startOf('isoWeek');
                calendar_end = moment(month_start).add(1, 'month').startOf('isoWeek');

                if((calendar_end.date() !== 1 && calendar_type === "weeks") || (calendar_end.date() !== 1 && month_count === months.length)){
                    calendar_end.add(1, 'week');
                }

                while(calendar_end.isAfter(calendar_start)){
                    if (calendar_start.day() === 1) {
                        let auxYear = moment(calendar_start).year()
                        let auxYear2 = moment(calendar_start).add(5, 'days').year()
                        let auxWeek = moment(calendar_start).week()
                        if(auxYear < auxYear2 && auxYear2 === end_date.year())
                            auxYear = auxYear2;
                        if(typeof weeks.where('year', auxYear).where('week', auxWeek).first() === 'undefined'){
                            html += '</tr><tr class="days"><td class="day select out-of-range"></td><td></td>';
                        }else{
                            var sel = (!b || (flag && hiatus_weeks.length > 0 && hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) !== -1)) ? 'unselected' : 'selected';
                            html += '</tr><tr class="days '+ sel +'"><td class="day select in-range" data-date="' + calendar_start.format('YYYY-MM-DD') + '"><i class="fa fa-check fa-fw"></i></td><td class="day weeknum"> ' + calendar_start.week() + '</td>';

                            if(inputs_container.find('input[name="campaign_weeks[]"][value="' + calendar_start.format('YYYY-MM-DD') + '"]').length === 0){
                                console.log("hiden: " + calendar_start.format('YYYY-MM-DD'));
                                if(validate_fufllfill === 0 && (!flag || hiatus_weeks.length == 0 || hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) === -1))
                                    inputs_container.append('<input type="hidden" name="campaign_weeks[]" value="' + calendar_start.format('YYYY-MM-DD') + '" value="true" />');
                            }
                        }
                    }

                    classes = 'day ';

                    if((parseInt(calendar_start.format('YYYYMMDD')) < parseInt(start_date.format('YYYYMMDD')))
                        || (parseInt(calendar_start.format('YYYYMMDD')) > parseInt(end_date.format('YYYYMMDD')))){
                        classes += 'out-of-range ';
                    }

                    if(value[0] !== calendar_start.format('M') && calendar_type === "weeks"){
                        classes += 'out-of-month ';
                    }

                    html += '<td class="' + classes + '">' + calendar_start.format('DD') + '</td>';

                    calendar_start.add(1, 'day');
                }
                html += '</tr>';

                html += '</tbody></table></div></div></div>';

                if(((month_count % 3) === 2) || (month_count === months.length)){
                    html += '</div>';
                }

                container.append(html);

                var auu = [];
                var hhtml = "";
                $.each($('td.day.select'), function(){
                    var auxx = $(this).attr('data-date');
                    if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                        var au = $(this).attr('data-date').split("-");
                        au = au[1] + " / " + au[2] + " / " + au[0];
                        if (auu.indexOf(au) === -1) {
                            auu.push(au);
                            hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                        }
                    }
                });
                $("#hiatus_weeks").html(hhtml);
                sort_hiatus();

                if(!b){
                    var upd_weeks = $("#update_weeks").val();
                    if(upd_weeks !== ""){
                        console.log("upd weeks");
                        console.log(upd_weeks);
                        var html = '';
                        var arr = upd_weeks.split('|');
                        var ins_aux = [];
                        // for(var i=0;i<arr.length-1;i++){
                        //     var aux1 = arr[i].split(' ');
                        //     console.log("divide");
                        //     console.log(aux1);
                        //     //var aux = aux1[4].split('-');
                        //     html += '<input type="hidden" name="campaign_weeks[]" value="'+ aux1[0].trim() +'">';
                        //     $.each($('td.day.select[data-date="' + aux1[0].trim() + '"]'), function(){
                        //         //$(this).closest('.days').removeClass('unselected').addClass('selected');
                        //     });
                        // }

                        $("#flight_weeks_inputs input").each(function (index,value) {
                            html += '<input type="hidden" name="campaign_weeks[]" value="'+ $(value).val().trim() +'">';
                            $.each($('td.day.select[data-date="' + $(value).val().trim() + '"]'), function(){
                                $(this).closest('.days').removeClass('unselected').addClass('selected');
                            });
                        })

                        // var auu = [];
                        // var hhtml = "";
                        // $.each($('td.day.select'), function(){
                        //     var auxx = $(this).attr('data-date');
                        //     if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                        //         var au = $(this).attr('data-date').split("-");
                        //         au = au[1] + " / " + au[2] + " / " + au[0];
                        //         if (auu.indexOf(au) === -1) {
                        //             auu.push(au);
                        //             hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                        //         }
                        //     }
                        // });
                        // $("#hiatus_weeks").html(hhtml);
                        // sort_hiatus();
                        inputs_container.html('');
                        inputs_container.html(html);
                    }
                }

            });

            if(lchange === 0) {
                console.log("EDIT");
                if (v === "w") {
                    last = v;
                    //$("#weeks_count").val($("#flight_weeks_inputs input").length);
                    console.log("WEEKS DIFFERENCE: ",calc_diff_weeks())
                    //$("#weeks_count").val(calc_diff_weeks());
                } else {
                    last = v;
                    //$("#weeks_count").val(calc_diff_days());
                }
            }

            $("#removeall").on('click', function(){
                $('#hiatus_weeks option').each(function(){
                    var daux = $(this).val().split(' / ');
                    daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                    var lastd = "";
                    container.find('td.day.select').each(function(){
                        var date = $(this).attr('data-date');
                        if(daux === date) {
                            console.log(date + "  " + lastd);
                            if(date !== lastd) {
                                $(this).click();
                                lastd = date;
                            }
                        }else
                            console.log(date + " " + daux);
                    });
                    $(this).remove();
                });
            });

            $("#removesel").on('click', function(){
                $('#hiatus_weeks option:selected').each(function(){
                    var daux = $(this).val().split(" / ");
                    daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                    var lastw = "";
                    container.find('td.day.select').each(function(){
                        var date = $(this).attr('data-date');
                        if(daux === date) {
                            if(date !== lastw) {
                                $(this).click();
                                lastw = date;
                            }
                        }else
                            console.log(date + " " + daux);
                    });
                    $(this).remove();
                });
                sort_hiatus();
            });

            if($('#has_orders').val() !== '1') {
                container.find('td.day.select').bind('click', function () {
                    date = $(this).attr('data-date');
                    var au = date.split("-");
                    au = au[1] + " / " + au[2] + " / " + au[0];

                    if ($(this).closest('.days').hasClass('selected')) {
                        $.each($('td.day.select[data-date="' + date + '"]'), function () {
                            $(this).closest('.days').addClass('unselected').removeClass('selected');
                        });
                        $('input[name="campaign_weeks[]"][value="' + date + '"]').remove();
                        console.log("au2: " + au);
                        $("#hiatus_weeks").html($("#hiatus_weeks").html() + '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>');
                        var v = $("input:radio[name=flength]:checked").attr('value');
                        // if (v === 'd')
                        //     $("#weeks_count").val(calc_diff_days());
                        // else
                        //     $("#weeks_count").val(parseInt($("#weeks_count").val()) - 1);
                        sort_hiatus();
                    } else {
                        $.each($('td.day.select[data-date="' + date + '"]'), function () {
                            $(this).closest('.days').removeClass('unselected').addClass('selected');
                        });
                        $('#flight_weeks_inputs').append('<input type="hidden" name="campaign_weeks[]" value="' + date + '" value="true" />');

                        $('#hiatus_weeks option').each(function () {
                            if ($(this).val() === au) {
                                $(this).remove();
                                return;
                            }
                        });
                        var v = $("input:radio[name=flength]:checked").attr('value');
                        // if (v === 'd')
                        //     $("#weeks_count").val(calc_diff_days());
                        // else
                        //     $("#weeks_count").val(parseInt($("#weeks_count").val()) + 1);
                        sort_hiatus();
                    }
                });
            }
            first = 0;
        }


        $('#show_archive_campaigns').on('change', function (){
            if($("#report_advertisers").val().length > 0) {
                var show = $('#show_archive_campaigns').is(':checked');
                $("#report_campaigns option").each(function () {
                    if( $(this).attr('archive') > 0 && show === true)
                        $(this).removeClass('hidden');
                    else if( $(this).attr('archive') > 0 && show === false)
                        $(this).addClass('hidden')
                });

                $("#report_campaigns").multiSelect("refresh");

                $(".select_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("select_all").multiSelect('refresh');
                });
                $(".deselect_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("deselect_all").multiSelect('refresh');
                });
            }
        });
        $("#report_advertisers").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_advertisers-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_advertisers-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();
                var arr = $('#report_products option:selected').map(function(){
                    return this.value
                }).get();
                var arr_adv = [];
                $('#report_advertisers option:selected').each(function () {
                    arr_adv.push($(this).attr('value'));
                });
                var params = {
                    'data': arr_adv,
                    'prod': arr,
                    'start': $('#date_range_11').val(),
                    'end': $('#date_range_22').val(),
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/advertiser/smart_report/search-campaigns',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        var selected_ar = $("#report_campaigns").val();
                        var html = '';
                        for (var i in response['campaigns_g']) {
                            html += '<optgroup id="adv_'+ i +'" label="'+ i.toUpperCase() +'">';
                            for(var ind in response['campaigns_g'][i]) {
                                if (response['campaigns_g'][i][ind].deleted_at === null || response['campaigns_g'][i][ind].archive_year > 0) {
                                    var text = response['campaigns_g'][i][ind].archive_year > 0 ? ' (Archived) ' : '';
                                    var selected = selected_ar.indexOf(response['campaigns_g'][i][ind].id) !== -1 ? 'selected' : '';
                                    html += '<option ' + selected + ' archive="' + response['campaigns_g'][i][ind].archive_year + '" value="' + response['campaigns_g'][i][ind].id + '" >' + response['campaigns_g'][i][ind].name + ' ' + text + '</option>';
                                }
                            }
                            html += '</optgroup>';
                        }
                        $("#report_campaigns").append(html).multiSelect("refresh");

                        //To SHOW or HIDE THE OPTION
                        var show = $('#show_archive_campaigns').is(':checked');

                        $("#report_campaigns option").each(function () {
                            if( $(this).attr('archive') > 0 && show === true)
                                $(this).removeClass('hidden');
                            else if( $(this).attr('archive') > 0 && show === false)
                                $(this).addClass('hidden')
                        });
                        $("#report_campaigns").multiSelect("refresh");
                        var html='';
                        for(var i in response['brands']){
                            html += '<option value="'+ response['brands'][i].slug +'">'+ response['brands'][i].name +'</option>';
                        }
                        $('#report_brands').html(html).multiSelect('refresh');

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });

            },
            afterDeselect: function(values){
                show_loader();
                $("#adv_" + values[0]).remove();
                $("#report_campaigns").multiSelect("refresh");
                $("#report_brands").multiSelect("refresh");
                $("#report_products").multiSelect("refresh");
                $(".select_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    $('#'+id).multiSelect("select_all").multiSelect('refresh');
                });

                $(".ddeselect_all_reports").on("click", function(){
                    var id = $(this).attr("id").split("-")[0];
                    console.log(id);
                    $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                    if(id == 'report_advertisers'){
                        $('#report_campaigns').html('').multiSelect('refresh');
                        $('#custom_markets').html('').multiSelect('refresh');
                        $('#dma_markets').html('').multiSelect('refresh');
                        $('#msa_markets').html('').multiSelect('refresh');
                        $('#report_brands').html('').multiSelect('refresh');
                        $('#report_products').html('').multiSelect('refresh');
                    }
                    else if(id == 'report_campaigns'){
                        $('#custom_markets').html('').multiSelect('refresh');
                        $('#dma_markets').html('').multiSelect('refresh');
                        $('#msa_markets').html('').multiSelect('refresh');
                        $('#report_brands').html('').multiSelect('refresh');
                        $('#report_products').html('').multiSelect('refresh');
                    }
                    else if(id =='report_brands')
                        $('#report_products').html('').multiSelect('refresh');
                });
                hide_loader();
            }
        });

        $("#report_campaigns").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_campaigns-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_campaigns-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();
                var arr = $('#report_campaigns option:selected').map(function(){
                    return this.value
                }).get();
                console.log(arr);
                var params = {
                    'data': arr
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search-markets/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        console.log(response);
                        var html = '';
                        var dma_markets = $("#dma_markets").val()
                        var msa_markets = $("#msa_markets").val()
                        var custom_markets = $("#custom_markets").val()
                        var media_types = [];
                        $(".report_media_types_div input:checked").each( function (){
                            media_types.push($(this).val());
                        });

                        for(var i in response['msa']){
                            var selected = (msa_markets.indexOf(response['msa'][i].slug) !== -1) ? "selected" : ""
                            html += '<option value="'+ response['msa'][i].slug +'" ' + selected + '>'+ response['msa'][i].name +'</option>';
                        }
                        $("#msa_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['dma']){
                            var selected = (dma_markets.indexOf(response['dma'][i].slug) !== -1) ? "selected" : ""
                            html += '<option value="'+ response['dma'][i].slug +'" ' + selected + '>'+ response['dma'][i].name +'</option>';
                        }
                        $("#dma_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['custom']){
                            var selected = (custom_markets.indexOf(response['custom'][i].slug) !== -1) ? "selected" : ""
                            html += '<option value="'+ response['custom'][i].slug +'" ' + selected + '>'+ response['custom'][i].name +'</option>';
                        }
                        $("#custom_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['medias']){
                            var selected = (media_types.indexOf(response['medias'][i].name) !== -1) ? "checked" : ""
                            html += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                '           <input id="report_media_' + response['medias'][i].name + '" ' +
                                '           name="report_media_types[]" type="checkbox" value="' + response['medias'][i].name + '"  ' + selected + '>' +
                                '           <label for="report_media_' + response['medias'][i].name + '"> ' + response['medias'][i].title + ' </label>' +
                                '                                                       </div>';

                        }
                        $(".report_media_types_div").html(html);

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        html = '';
                        for(var i in response['brands']){
                            var selected ='';
                            html += '<option value="'+ response['brands'][i].id +'" ' + selected + '>'+ response['brands'][i].name +'</option>';
                        }
                        $("#report_brands").html(html);

                        $("#report_products").html('').multiSelect("refresh");

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            },
            afterDeselect: function(values){
                show_loader();
                var arr = $('#report_campaigns option:selected').map(function(){
                    return this.value
                }).get();
                console.log(arr);
                var params = {
                    'data': arr
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search-markets/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        console.log(response);

                        var html = '';
                        for(var i in response['msa']){
                            html += '<option value="'+ response['msa'][i].slug +'">'+ response['msa'][i].name +'</option>';
                        }
                        $("#msa_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['dma']){
                            html += '<option value="'+ response['dma'][i].slug +'">'+ response['dma'][i].name +'</option>';
                        }
                        $("#dma_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['custom']){
                            html += '<option value="'+ response['custom'][i].slug +'">'+ response['custom'][i].name +'</option>';
                        }
                        $("#custom_markets").html(html).multiSelect("refresh");

                        html = '';
                        for(var i in response['medias']){
                           // html += '<option value="'+ response['medias'][i].name +'">'+ response['medias'][i].title +'</option>';
                            html += '<div class="checkbox-danger checkbox-inline checkbox" style="margin-left: 2%">' +
                                '           <input id="report_media_' + response['medias'][i].name + '" ' +
                                '           name="report_media_types[]" type="checkbox" value="' + response['medias'][i].name + '">' +
                                '           <label for="report_media_' + response['medias'][i].name + '"> ' + response['medias'][i].title + ' </label>' +
                                '                                                       </div>';
                        }
                        $(".report_media_types_div").html(html);

                        html = '';
                        for(var i in response['brands']){
                            var selected = '';
                            html += '<option value="'+ response['brands'][i].id +'" ' + selected + '>'+ response['brands'][i].name +'</option>';
                        }
                        $("#report_brands").html(html);
                        $("#report_products").html('').multiSelect("refresh");

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            }
        });


       // fill_campaign_button();
       //  function fill_campaign_button() {
       //      var smart_camp_general_int = [];
       //      for(var i in smart_camp_general)
       //          smart_camp_general_int.push(parseInt(smart_camp_general[i]));
       //      var camp_html = '';
       //      for (var i in campaigns_all_general) {
       //          var b = campaigns_all_general[i];
       //          console.log('campaigns_all_general[i]    ', b)
       //          console.log('campaigns_all_general[i]    smart_camp_general', smart_camp_general)
       //          var optgroup = '';
       //          var text = b['archive_year'] > 0 ? ' (Archived) ' : '';
       //          if (b.adv_name !== optgroup)
       //              camp_html += '<optgroup id="' + b.adv_slug + '" label="' + b.adv_name.toUpperCase() + '">';
       //          var selected = smart_camp_general_int.indexOf(parseInt(b.id)) !== -1 ? 'selected' : '';
       //          camp_html += '<option  value="' + b.id + '" ' + selected + ' archive="'+ b.archive_year +'"> ' + b.name + ' ' + text + '</option>';
       //          if (b.adv_name !== optgroup)
       //              camp_html += '</optgroup>';
       //          optgroup = b.adv_name;
       //      }
       //      $("#report_campaigns").html(camp_html).multiSelect("refresh");
       //
       //      //To SHOW or HIDE THE OPTION
       //      if(report_show_archive_campaigns === 1)
       //         $('#show_archive_campaigns').prop('checked', true);
       //      var show = $('#show_archive_campaigns').is(':checked');
       //      $("#report_campaigns option").each(function () {
       //          if( $(this).attr('archive') > 0 && show === true)
       //              $(this).removeClass('hidden');
       //          else if( $(this).attr('archive') > 0 && show === false)
       //              $(this).addClass('hidden')
       //      });
       //      $("#report_campaigns").multiSelect("refresh");
       //  }

        $("#custom_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="custom_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='custom_details-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#display_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="display_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='display_details-deselect_all_det2'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#estimate_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="estimate_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='estimate_details-deselect_all_det3'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });
        $("#approved_details").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="approved_details-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='approved_details-deselect_all_det4'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#dma_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="dma_markets-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='dma_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#msa_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="msa_markets-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='msa_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#custom_markets").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="custom_markets-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='custom_markets-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){

            }
        });

        $("#report_brands").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_brands-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_brands-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {
                show_loader();

                var params = {
                    'data': $('#report_brands').val()
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        console.log('products response', response);
                        var prod_sel=[];
                        $('#report_products option:selected').each(function(){
                            prod_sel.push($(this).val());
                        });
                        // for(var i in response['products']){
                        //     html += '<option value="'+ response['products'][i].slug +'">'+ response['products'][i].name +'</option>';
                        // }
                        var html_prod ='';
                        for(var i in response['products']){
                            var ss='';
                            if(prod_sel.indexOf(response['products'][i].slug) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + response['products'][i].slug + '" '+ss+'> ' + response['products'][i].name + ' </option>';
                        };
                        $("#report_products").html(html_prod).multiSelect("refresh");

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            },
            afterDeselect: function(values){
                show_loader();

                var params = {
                    'data': $('#report_brands').val(),
                };
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/smart/reports/campaign/search/products',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (response) {
                        // var html='';
                        // for(var i in response['products']){
                        //     html += '<option value="'+ response['products'][i].slug +'">'+ response['products'][i].name +'</option>';
                        // }
                        // $("#report_products").html(html).multiSelect("refresh");
                        console.log('products response', response);
                        var prod_sel=[];
                        $('#report_products option:selected').each(function(){
                            prod_sel.push($(this).val());                        });

                        var html_prod ='';
                        for(var i in response['products']){
                            var ss='';
                            if(prod_sel.indexOf(response['products'][i].slug) !==-1)
                                ss = 'selected';
                            html_prod += '<option value="' + response['products'][i].slug + '" '+ss+'> ' + response['products'][i].name + ' </option>';
                        };
                        $("#report_products").html(html_prod).multiSelect("refresh");

                        $(".select_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            $('#'+id).multiSelect("select_all").multiSelect('refresh');
                        });

                        $(".ddeselect_all_reports").on("click", function(){
                            var id = $(this).attr("id").split("-")[0];
                            console.log(id);
                            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
                            if(id == 'report_advertisers'){
                                $('#report_campaigns').html('').multiSelect('refresh');
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id == 'report_campaigns'){
                                $('#custom_markets').html('').multiSelect('refresh');
                                $('#dma_markets').html('').multiSelect('refresh');
                                $('#msa_markets').html('').multiSelect('refresh');
                                $('#report_brands').html('').multiSelect('refresh');
                                $('#report_products').html('').multiSelect('refresh');
                            }
                            else if(id =='report_brands')
                                $('#report_products').html('').multiSelect('refresh');
                        });

                        hide_loader();
                    },
                    error: function (xhr) {
                        hide_loader();
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
                hide_loader();
            }
        });

        $("#report_products").multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_reports" value="Select All" id="report_products-select_all_det1">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm ddeselect_all_reports' value='Deselect All' id='report_products-deselect_all_det1'>" +'</div>',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values) {

            },
            afterDeselect: function(values){
            }
        });

        $(".direct_access_date").on("click", function(){
            var id = $(this).attr("id");
            var opt = $('input[name="calendar_type"]:checked').val();
            var day_no = moment().isoWeekday();
            console.log(id);
            console.log(opt);
            range_option_selected = id;
            if(opt === 'broadcast') {
                if (id === "month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") === month){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    $("#date_range_11").val(first);
                    $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "last_month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month){
                    }
                    var month1 = sunday.format("M");
                    while(sunday.subtract(7, 'days').format("M") === month1){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") === month1){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");

                } else if (id === "6_month") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    if(month < 7){
                        while(sunday.subtract(7, 'days').format("M") < 7){
                        }
                        var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                        sunday = sunday.add(6, 'days');
                        while(sunday.add(7, "days").format("M") < 7){
                        }
                        var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                        console.log(first+" / "+end);
                        // $("#date_range_11").val(first);
                        // $("#date_range_22").val(end);
                        $("#date_range_11").data('daterangepicker').setStartDate(first);
                        $("#date_range_22").data('daterangepicker').setStartDate(end);
                        $("#date_range_22").trigger("change");
                    }else{
                        while(sunday.subtract(7, 'days').format("M") > 7){
                        }
                        var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                        sunday = sunday.add(6, 'days');
                        while(sunday.add(7, "days").format("M") > 7){
                        }
                        var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                        console.log(first+" / "+end);
                        // $("#date_range_11").val(first);
                        // $("#date_range_22").val(end);
                        $("#date_range_11").data('daterangepicker').setStartDate(first);
                        $("#date_range_22").data('daterangepicker').setStartDate(end);
                        $("#date_range_22").trigger("change");
                    }
                } else if (id === "quarter") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var month = sunday.format("M");
                    var from = 1;
                    var end = 4;
                    if(month < 4) {
                        from = 1;
                        end = 4;
                    }else if(month < 7) {
                        from = 3;
                        end = 7;
                    }else if(month < 10) {
                        from = 6;
                        end = 10;
                    }else {
                        from = 9;
                        end = 13;
                    }
                    while(sunday.subtract(7, 'days').format("M") > from && sunday.format("M") <= end){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(6, 'days');
                    while(sunday.add(7, "days").format("M") < end && sunday.format("M") >= from){
                    }
                    var end = sunday.subtract(7, 'days').format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "year") {
                    var sunday = moment().add((7 - day_no), 'days');
                    var year = sunday.format("YYYY");
                    while(sunday.subtract(7, 'days').format("YYYY") === year){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(363, 'days');
                    var end = sunday.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else { //last_year
                    var sunday = moment().add((7 - day_no), 'days');
                    var year = sunday.format("YYYY");
                    while(sunday.subtract(7, 'days').format("YYYY") >= year - 1){
                    }
                    var first = sunday.add(1, 'days').format("MM/DD/YYYY");
                    sunday = sunday.add(363, 'days');
                    var end = sunday.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_11").val(first);
                    // $("#date_range_22").val(end);
                    $("#date_range_11").data('daterangepicker').setStartDate(first);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                }
            }else{
                if (id === "month") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    // $("#date_range_11").val(month+"/01/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate(month+"/01/"+year);
                    var first = moment(month+"-01-"+year, "MM-DD-YYYY");
                    while(first.add(1, 'days').format("MM") === month){
                    }
                    var end = first.subtract(1, 'days').format("MM/DD/YYYY")
                    // $("#date_range_22").val(end);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "last_month") {
                    var today = moment();
                    var month1 = moment().format("MM");
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    if(month === "01"){
                        month = "12";
                        year = parseInt(year) - 1;
                    }else{
                        month = parseInt(month) - 1;
                    }
                    // $("#date_range_11").val(month+"/01/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate(month+"/01/"+year);
                    var first = moment(month+"-01-"+year, "M-DD-YYYY");
                    while(today.subtract(1, 'days').format("MM") === month1){
                    }
                    var end = today.format("MM/DD/YYYY");
                    console.log(first+" / "+end);
                    // $("#date_range_22").val(end);
                    $("#date_range_22").data('daterangepicker').setStartDate(end);
                    $("#date_range_22").trigger("change");
                } else if (id === "6_month") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    if(parseInt(month) > 6){
                        // $("#date_range_11").val("06/01/"+year);
                        // $("#date_range_22").val("12/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("06/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    }else{
                        // $("#date_range_11").val("01/01/"+year);
                        // $("#date_range_22").val("06/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("06/30/"+year);
                    }
                    $("#date_range_22").trigger("change");
                } else if (id === "quarter") {
                    var month = moment().format("MM");
                    var year = moment().format("YYYY");
                    var intmonth = parseInt(month);
                    if(intmonth > 0 && intmonth < 4){
                        // $("#date_range_11").val("01/01/"+year);
                        // $("#date_range_22").val("03/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("03/31/"+year);
                    }else if(intmonth > 3 && intmonth < 7){
                        // $("#date_range_11").val("04/01/"+year);
                        // $("#date_range_22").val("06/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("04/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("06/30/"+year);
                    }else if(intmonth > 5 && intmonth < 10){
                        // $("#date_range_11").val("07/01/"+year);
                        // $("#date_range_22").val("09/30/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("07/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("09/30/"+year);
                    }else{
                        // $("#date_range_11").val("10/01/"+year);
                        // $("#date_range_22").val("12/31/"+year);
                        $("#date_range_11").data('daterangepicker').setStartDate("10/01/"+year);
                        $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    }
                    $("#date_range_22").trigger("change");
                } else if (id === "year") {
                    var year = moment().format("YYYY");
                    // $("#date_range_11").val("01/01/"+year);
                    // $("#date_range_22").val("12/31/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                    $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    $("#date_range_22").trigger("change");
                } else { //last_year
                    var year = moment().format("YYYY");
                    year--;
                    // $("#date_range_11").val("01/01/"+year);
                    // $("#date_range_22").val("12/31/"+year);
                    $("#date_range_11").data('daterangepicker').setStartDate("01/01/"+year);
                    $("#date_range_22").data('daterangepicker').setStartDate("12/31/"+year);
                    $("#date_range_22").trigger("change");
                }
            }
            fd_changed_in= 1;
        });

        $(".select_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            $('#'+id).multiSelect("select_all").multiSelect('refresh');
        });

        $(".ddeselect_all_reports").on("click", function(){
            var id = $(this).attr("id").split("-")[0];
            console.log(id);
            $('#'+id).multiSelect('deselect_all').multiSelect('refresh');
            if(id == 'report_advertisers'){
                $('#report_campaigns').html('').multiSelect('refresh');
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id == 'report_campaigns'){
                $('#custom_markets').html('').multiSelect('refresh');
                $('#dma_markets').html('').multiSelect('refresh');
                $('#msa_markets').html('').multiSelect('refresh');
                $('#report_brands').html('').multiSelect('refresh');
                $('#report_products').html('').multiSelect('refresh');
            }
            else if(id =='report_brands')
                $('#report_products').html('').multiSelect('refresh');
        });

        if(report_ob.report_type === 'mediastruction_report'){
            if(report_ob.automate_report === 1) {
                if(report_ob.time_frame === 'weekly') {
                    $('#time_frame_weekly').prop('checked', true);
                    var i = 1;
                    var weeks = 54;
                    var html = '';
                    while(i < weeks) {
                        var sel = i === parseInt(report_ob.number_of_weeks) ? 'selected' : '';
                        html += '<option value="' + i + '" ' + sel + '>' + i + '</option>';
                        i++;
                    }
                    $('#monthly_monthly').html('').select2({
                        closeOnSelect: true
                    }).html(html);

                    $('#monthly_monthly_div').show();
                }
                else if(report_ob.time_frame === 'monthly'){
                    $('#time_frame_monthly').prop('checked', true);
                    $('.monthly_monthly_div').hide();
                }
                else{
                    $('#time_frame_quarterly').prop('checked', true);
                    $('.monthly_monthly_div').hide();
                }
                $('#email_to_aut').val(report_ob.email_to_aut);

                $('#automate_report_hidden').val(true);
                //Hide
                $('.direct_access_date_div').hide();
                $('.flight_weeks_container_div').hide();
                $('#date_range_22').hide();

                $('#date_range_11').val(moment(report_ob.start).format('MM/DD/YYYY'))
                $('#date_range_11').daterangepicker({
                    "showWeekNumbers": false,
                    "singleDatePicker": true,
                    "startDate": moment(report_ob.start),
                    "minDate": moment(report_ob.start),
                    //"endDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
                    // "autoApply": true,
                    // "dateLimit": {
                    //     "weeks": 53
                    // },
                    // "linkedCalendars": false,
                    // "locale": {
                    //     "format": "MM/DD/YYYY",
                    //     "separator": " - ",
                    //     "applyLabel": "Apply",
                    //     "cancelLabel": "Cancel",
                    //     "fromLabel": "From",
                    //     "toLabel": "To",
                    //     "customRangeLabel": "Custom",
                    //     "weekLabel": "#",
                    //     "daysOfWeek": [
                    //         "U",
                    //         "M",
                    //         "T",
                    //         "W",
                    //         "R",
                    //         "F",
                    //         "S"
                    //     ],
                    //     "firstDay": 1
                    // }
                });
                $('#date_range_22').val(moment().add(2, 'y').format('MM/DD/YYYY'))
                $('#date_range_11').trigger('change')
                $('#date_range_22').trigger('change')

                //Show
                $('.automate_period_div').show();
                $('.send_email_to_aut').show();
            }
            else
                $('#automate_report').show();

            $('#automate_report').on('click', function () {
                automate_report();

            });

            function automate_report(){
                $('#automate_report_hidden').val(true);
                //Hide
                $('.direct_access_date_div').hide();
                $('.flight_weeks_container_div').hide();
                $('#date_range_22').hide();

                $('#date_range_11').val(moment(report_ob.start).format('MM/DD/YYYY'))
                $('#date_range_11').daterangepicker({
                    "showWeekNumbers": false,
                    "singleDatePicker": true,
                    "startDate": moment(report_ob.start),
                    "minDate": moment(report_ob.start),
                });

                $('#date_range_22').val(moment().add(2, 'y').format('MM/DD/YYYY'))
                $('#date_range_11').trigger('change')
                $('#date_range_22').trigger('change')

                //Show
                $('.automate_period_div').show();
                $('#monthly_monthly_div').show();
                $('.send_email_to_aut').show();


                change_automate_period();
            }
            $('.automate_period_div input[type=radio]').on('change', function () {
                change_automate_period();
            });

            function change_automate_period( number_of_weeks = null){
                if($("input:radio[name=time_frame]:checked").attr('value')  === 'weekly'){
                    var quarter = [];
                    var i = 1;
                    var weeks = 54;
                    while(i < weeks) {
                        quarter.push({'id': i, 'text': i});
                        i++;
                    }
                    $('#monthly_monthly').html('').select2({
                        'data': quarter,
                        closeOnSelect: true
                    });

                    $('#monthly_monthly_div').show();
                }
                else
                    $('#monthly_monthly_div').hide();
            }
        }

    });
}
